var _excluded = ["children", "with_trial", "no_legal", "legal_before_btn"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/ /*global bluesnap*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['virt_jquery_all', 'react', 'react-dom', 'pub_config', '/www/util/pub/pure_component.js', '/util/url.js', 'hola_opt', '/util/etask.js', 'classnames', 'zutil', 'lodash.difference', '/svc/billing/pub/pay_ccardbs.js', '/www/hola/pub/be.js', '/svc/account/pub/membership.js', '/www/hola/pub/plus_util.js', '/www/hola/pub/eec.js', '/www/hola/pub/gtm.ts', '/util/zerr.js', '/svc/billing/pub/payutils.js', 'md5', '/www/hola/pub/react_util.js', '/util/country.js', '/util/util.js', '/www/hola/pub/lib/select.tsx', '/www/hola/pub/lib/modal.tsx', '/www/hola/pub/util.js', '/util/date.js', '/www/hola/pub/plans_util.js', 'react-router-dom', 'react-i18next', '/www/hola/pub/lib/tooltip.js', '/www/hola/pub/experiment_init', '/www/hola/pub/experiment_util', '/util/events.js', '/www/hola/pub/plus/currency_select.tsx', '/www/hola/pub/plus/woops_payment.tsx', '/www/hola/pub/plus/susp_payment.tsx', '/www/hola/pub/lib/input.js', '/www/hola/pub/settings_ctx.tsx', '/www/hola/pub/context.js', '/www/hola/pub/lib/button.tsx', '/www/hola/pub/ui/premium/tab_buttons.tsx', '/www/hola/pub/ui/adyen/cc_adyen.tsx'], ($, React, ReactDOM, config, Pure_component, zurl, hopt, etask, cn, _, _difference, pay_ccardbs, be, zmembership, plus_util, eec, gtm, zerr, payutils, md5, react_util, zcountry, zutil, Select, Modal, www_util, date, plans_util, RRD, react_i18n, {
  Tooltip
}, experiment_init, experiment_util, events, {
  Currency_select
}, {
  Woops_payment,
  Woops_payment_hola2023,
  Woops_payment_oculus,
  Woops_payment_browserai
}, {
  Susp_payment,
  Susp_payment_hola2023
}, {
  Input
}, {
  Settings_context,
  Modal_singleton,
  Callback_context
}, {
  App_context
}, {
  Button
}, {
  Tab_buttons
}, {
  CC_adyen
}) => {
  var _Class;
  var E = {};
  var SEC = date.ms.SEC;
  var sys = www_util.sys;
  var perr = plus_util.perr,
    empty_email_err = plus_util.empty_email_err,
    test_log = plus_util.test_log,
    test_log_error = plus_util.test_log_error;
  var url2md5 = config.url2md5;
  var useHistory = RRD.useHistory;
  var assign = Object.assign;
  var useState = React.useState,
    useEffect = React.useEffect,
    useRef = React.useRef,
    Fragment = React.Fragment,
    useMemo = React.useMemo,
    useContext = React.useContext;
  var useTranslation = react_i18n.useTranslation,
    Trans = react_i18n.Trans;
  var qs_o = () => zurl.qs_parse(location.search.substr(1), {
    safe: true
  });
  var get_bluesnap_card_brand_icon = brand => 'https://pay.bluesnap.com/web-sdk/5/assets/cards/' + brand + '.png';
  E.emitter = new events.EventEmitter();
  experiment_init = experiment_init.default;
  experiment_util = experiment_util.default;
  var get_payment_order = () => experiment_init.ui_test.test_pm_order && experiment_init.ui_test_conf.test_pm_order.order || ['cc', 'paypal', 'applepay', 'gpay', 'other'];
  var err_dlg = (id = 'stripe_err', is_hola2023 = false, theme_name) => {
    if (!is_hola2023) Modal_singleton.show_modal(id, Woops_payment, {
      width: 440
    });else {
      theme_name == 'oculus' ? Modal_singleton.show_modal(id, Woops_payment_oculus, {
        width: 480
      }) : theme_name == 'browserai' ? Modal_singleton.show_modal(id, Woops_payment_browserai, {
        width: 435
      }) : Modal_singleton.show_modal(id, Woops_payment_hola2023, {
        width: 335
      });
    }
  };
  window.test_err_dlg = err_dlg;
  var susp_dlg = (id = 'stripe_susp', is_hola2023 = false) => {
    if (!is_hola2023) Modal_singleton.show_modal(id, Susp_payment, {
      width: 440
    });else Modal_singleton.show_modal(id, Susp_payment_hola2023, {
      width: 335
    });
  };
  var b64_encode_unicode = str => btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode('0x' + p1)));
  var is_bluesnap_vat = () => zutil.get(plus_util, 'test.cc_payment.bluesnap.ext.vat_on');
  var gpay_base_request = {
    apiVersion: 2,
    apiVersionMinor: 0
  };
  var gpay_base_card_pm = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
      allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA']
    }
  };
  var send_submit_event = () => {};
  var bs_merchant_id = _.get(hopt, 'www_hola.bluesnap_merchant_id.' + (plus_util.api.test_env ? 'test' : 'prod'));
  var submit_err_render = (err, id) => {
    var reason_code = err.reason_code,
      reason = err.reason;
    var render_retry = (text, retry_text) => text.replace('try_again', id ? '<strong id=ccard_retry>' + retry_text + '</strong>' : retry_text);
    if (reason_code == 'INVALID_INFORMATION') {
      if (reason == 'Invalid 3DS') {
        return 'Transaction declined due to failed 3D ' + 'Secure authentication' + render_retry(', please try_again', 'try again');
      }
    }
    if (reason_code == 'EXPIRED') {
      return 'Card is expired, please try with another ' + 'credit card';
    }
    if (reason_code == 'DISABLED') {
      return 'Card is disabled, please try with another ' + 'credit card';
    }
    return plus_util.get_err_text(err);
  };
  var wait_for_download_scripts = () => {
    if (hopt.cookie_value_parsed && hopt.cookie_value_parsed.n) return true;
    var et = etask.wait();
    if (!window.global_etask_for_wait_cookie) window.global_etask_for_wait_cookie = [];
    window.global_etask_for_wait_cookie.push(() => et.continue(true));
    return et;
  };
  E.wait_for_download_scripts = wait_for_download_scripts;
  var gpay_init = {};
  var init_gpay = on_err => etask(function* () {
    yield wait_for_download_scripts();
    if (gpay_init.ready !== undefined) return gpay_init;
    if (gpay_init.et) return gpay_init.et;
    gpay_init.et = this;
    if (!window.google) {
      yield payutils.load_script('https://pay.google.com/gp/p/js/pay.js', null, on_err);
    }
    if (!window.google) return assign(gpay_init, {
      et: null,
      err: true,
      ready: false
    });
    if (!gpay_init.client) {
      gpay_init.client = new window.google.payments.api.PaymentsClient({
        environment: plus_util.api.test_env ? 'TEST' : 'PRODUCTION'
      });
    }
    if (!gpay_init.client) return {};
    return gpay_init.client.isReadyToPay(assign({}, gpay_base_request, {
      allowedPaymentMethods: [gpay_base_card_pm]
    })).then(res => {
      perr({
        id: 'www_premium_payment_bluesnap_gpay_inited'
      });
      return assign(gpay_init, {
        ready: !!res.result,
        et: null,
        err: false
      });
    }).catch(err => {
      perr({
        id: 'www_premium_payment_bluesnap_gpay_init_err',
        info: {
          err: zerr.e2s(err)
        }
      });
      return assign(gpay_init, {
        et: null,
        ready: false,
        err: err || true
      });
    });
  });
  var applepay_init = {};
  var is_supports_applepay = () => etask(() => {
    if (applepay_init.res !== undefined) return applepay_init.res;
    if (!window.ApplePaySession) {
      assign(applepay_init, {
        res: false
      });
      return false;
    }
    var domain = window.location.hostname;
    if (!zutil.get(hopt, 'www_hola.bluesnap_applepay_domains').includes(domain)) {
      assign(applepay_init, {
        res: false
      });
      return false;
    }
    if (applepay_init.et) return applepay_init.et;
    applepay_init.et = this;
    return window.ApplePaySession.canMakePaymentsWithActiveCard(bs_merchant_id + '-' + domain).then(res => {
      perr({
        id: 'www_premium_payment_bluesnap_applepay_' + (res ? '' : 'not_') + 'supported'
      });
      assign(applepay_init, {
        res,
        et: null
      });
      return res;
    }).catch(err => {
      perr({
        id: 'www_premium_payment_bluesnap_applepay_init_err',
        info: {
          err: zerr.e2s(err)
        }
      });
      assign(applepay_init, {
        res: false,
        et: null
      });
      return false;
    });
  });
  var init_avangate = on_err => etask(function* () {
    yield wait_for_download_scripts();
    var conf = zutil.get(hopt, 'www_hola.avangate_inline', {});
    var use_avangate_inline = qs_o().avangate_inline || conf && (conf.plan || conf.pm || conf.fallback);
    var tasks = [];
    if (use_avangate_inline) {
      tasks.push(payutils.load_script('https://secure.avangate.com/checkout/client/twoCoInlineCart.js', null, on_err));
    }
    if (plus_util.api.avangate_2pay_enabled) {
      tasks.push(payutils.load_script('https://2pay-js.2checkout.com/v1/2pay.js', null, on_err));
    }
    // XXX vitaly: check what is this and do we need it
    tasks.push(payutils.load_script('https://secure.avangate.com/js/encryption/cart-v1.0.js', null, on_err));
    return yield etask.all(tasks);
  });
  var init_stripe = on_err => etask(function* () {
    test_log('init stripe');
    yield wait_for_download_scripts();
    yield payutils.load_script('https://js.stripe.com/v3/', null, on_err);
  });
  E.init = (api, on_err) => etask(function* () {
    if (!self.hola_fetch) return;
    var qs = qs_o();
    test_log('init payment scripts', api);
    yield wait_for_download_scripts();
    yield etask.all(qs.with_trial ? [api.stripe_enabled && init_stripe()] : [api.avangate_enabled && init_avangate(on_err), (api.gpay || api.gpay_stripe) && init_gpay(on_err), api.applepay && is_supports_applepay(), api.bluesnap_hpf_enabled && pay_ccardbs._init_bluesnap({
      sbx: api.test_env,
      vat: is_bluesnap_vat(),
      init_hpf: api.bluesnap_hpf_enabled,
      on_3ds: plus_util.on_3ds
    }, on_err), api.stripe_enabled && init_stripe()]);
    test_log('inited payment scripts');
  });
  var Spinner = ({
    small
  }) => /*#__PURE__*/React.createElement("img", {
    src: url2md5('/www/util/pub/img/spinner' + (small ? '.gif' : '_big.png')),
    className: cn('spinner', 'lazyload'),
    alt: "spinner"
  });
  var tooltip_cn = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "This is a 16-digit number on the front of your card:"), /*#__PURE__*/React.createElement("div", {
    className: "tt_imgs"
  }, /*#__PURE__*/React.createElement("img", {
    src: plus_util.img_url('ic_card_number.svg'),
    alt: "ic_card",
    className: "lazyload"
  })));
  var tooltip_cvv = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "This is a 3 digit number on your VISA, MasterCard or Discovery, or a 4 digit number on your American Express."), /*#__PURE__*/React.createElement("p", null, "Security code can be located by looking on your card, as illustrated below:"), /*#__PURE__*/React.createElement("div", {
    className: "tt_imgs"
  }, /*#__PURE__*/React.createElement("img", {
    src: plus_util.img_url('cvv_amex.svg'),
    alt: "ic_amex",
    className: "lazyload"
  }), /*#__PURE__*/React.createElement("img", {
    src: plus_util.img_url('cvv_visa.svg'),
    alt: "ic_visa",
    className: "lazyload"
  })));
  var Legal = ({
    plan,
    currency,
    vat_obj,
    provider,
    legal_tiny_size,
    class_name,
    summary_test,
    secured_elems_test,
    checkout_text_test,
    with_trial
  }) => {
    var _ref = zmembership.get_price_plan(plan, currency) || {},
      price = _ref.price,
      renewal_price = _ref.renewal_price,
      erf_amount = _ref.erf_amount;
    var _useContext = useContext(Settings_context),
      theme = _useContext.theme,
      theme_name = _useContext.theme_name;
    var is_hola2023 = theme_name != 'default';
    var vat = get_vat_res(vat_obj, price, provider);
    if (vat && renewal_price) {
      vat.price = (renewal_price * (1 + vat.vat_percent / 100)).toFixed(2);
      vat.vat = (vat.price - renewal_price).toFixed(2);
    }
    var _price = vat ? vat.price : renewal_price || price;
    var vat_info = vat && /*#__PURE__*/React.createElement(Vat_info, _extends({}, vat, {
      currency: currency
    }));
    var initial_per = plan.free_period && zmembership.get_per(zmembership.sum_period(plan.period, plan.free_period), true);
    var cls = is_hola2023 ? theme.p5 : legal_tiny_size ? theme.tiny : theme.xs;
    var link_cls = !is_hola2023 && !legal_tiny_size && theme.bold || '';
    var erf_text = erf_amount && !{
      '1 M': 1,
      '1 W': 1
    }[plan.period] ? /*#__PURE__*/React.createElement(Fragment, null, "Total amount includes an exchange rate fee.", ' ') : null;
    var renewal = with_trial ? /*#__PURE__*/React.createElement(Fragment, null, "Your subscription will automatically renew every ", plan.every, ". You will be charged ", zcountry.format_price(currency, _price), " on each renewal until you cancel it by submitting a help desk request here.") : renewal_price ? /*#__PURE__*/React.createElement(Fragment, null, erf_text, "After the initial period, you will be charged ", zcountry.format_price(currency, _price), " ", vat_info, " every ", plan.every, " fee until you cancel the subscription.") : checkout_text_test ? /*#__PURE__*/React.createElement(Fragment, null, erf_text, "You can cancel the renewal by submitting a help desk request ", /*#__PURE__*/React.createElement("a", {
      href: "/cp",
      target: "_blank"
    }, "here"), ".") : /*#__PURE__*/React.createElement(Fragment, null, erf_text, "Your subscription will automatically renew every ", plan.every, initial_per && ' after initial period of ' + initial_per, ". You will be charged ", zcountry.format_price(currency, _price), " ", vat_info, " on each renewal until you cancel it by submitting a help desk request ", /*#__PURE__*/React.createElement("a", {
      href: "/cp",
      target: "_blank"
    }, "here"), ".");
    return /*#__PURE__*/React.createElement("div", {
      className: cn('legal', legal_tiny_size && 'legal_tiny_size', class_name)
    }, summary_test ? /*#__PURE__*/React.createElement("div", {
      className: "money_back_line"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('/hola2023/icons/16/wavy_check.svg'),
      alt: "wavy_check",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("p", {
      className: cn(theme.p4, theme.med)
    }, "You're 100% backed by our Money-Back guarantee ", /*#__PURE__*/React.createElement("a", {
      href: "/faq#refund-policy",
      target: "_blank",
      rel: "noopener noreferrer",
      className: link_cls
    }, "Policy"), ".")) : !secured_elems_test && /*#__PURE__*/React.createElement("p", {
      className: cls
    }, "You're 100% backed by our money-back guarantee ", /*#__PURE__*/React.createElement("a", {
      href: "/faq#refund-policy",
      target: "_blank",
      rel: "noopener noreferrer",
      className: link_cls
    }, "policy"), "."), !summary_test && (!renewal_price || renewal_price === price) && /*#__PURE__*/React.createElement("p", {
      className: cls
    }, renewal, " If you cancel, previous charges will not be refunded, but you may continue to use the service until the end of the term you paid for."), /*#__PURE__*/React.createElement("div", {
      className: "privacy"
    }, /*#__PURE__*/React.createElement("p", {
      className: summary_test ? theme.p4 : cls
    }, /*#__PURE__*/React.createElement("span", null, "By submitting this form, you agree to our "), /*#__PURE__*/React.createElement("a", {
      href: "/legal/sla",
      target: "_blank",
      className: link_cls
    }, "Terms of Service"), /*#__PURE__*/React.createElement("span", null, " and "), /*#__PURE__*/React.createElement("a", {
      href: "/legal/privacy",
      target: "_blank",
      className: link_cls
    }, "Privacy Policy"), "."), summary_test && /*#__PURE__*/React.createElement("p", {
      className: theme.p4
    }, "Your subscription will automatically renew every ", plan.every, ". A recurring payment will be billed at the end of each subscription period. You can stop auto-renewal in your account settings.")));
  };
  E.Legal = Legal;
  var Paypal_payment_btn = props => {
    var _useContext2 = useContext(Settings_context),
      theme_name = _useContext2.theme_name;
    var submit_payment = props.submit_payment,
      currency = props.currency;
    var is_hola2023 = theme_name != 'default';
    var submitting = props.submitting && props.last_submit_is('paypal', 'webscr');
    var btn_cls = cn('button button-large button-paypal', submitting && 'active', props.legal_before_btn && 'paypal-btn-after-legal');
    var paypal_img = 'paypal_enabled.svg';
    var email = props.email,
      email_error = props.email_error;
    var submit = () => {
      send_submit_event();
      if (!props.user && (!email || email_error)) return void props.set_email_err(email_error || empty_email_err);
      submit_payment('old_paypal');
    };
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      tabIndex: "38",
      onClick: submit
    }, is_hola2023 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "button-paypal-label"
    }, "Checkout with"), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(paypal_img),
      alt: "paypal_icon",
      className: cn('paypal-icon', 'lazyload')
    })) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "Checkout with "), /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(paypal_img),
      alt: "paypal_img",
      className: "lazyload"
    })))), /*#__PURE__*/React.createElement("form", {
      id: "paypal_form",
      className: "hidden",
      method: "post",
      action: "https://www.paypal.com/cgi-bin/webscr"
    }, /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "business",
      value: _.get(hopt, 'paypal.live.account')
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "cmd",
      value: "_xclick-subscriptions"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "item_name",
      value: "Hola Subscription"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "p3",
      value: "1"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "src",
      value: "1"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "currency_code",
      value: currency
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "no_shipping",
      value: "1"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "image_url",
      value: plus_util.img_url('logo.png')
    })));
  };
  var With_legal = props => {
    var children = props.children,
      with_trial = props.with_trial,
      no_legal = props.no_legal,
      legal_before_btn = props.legal_before_btn,
      rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: "with_legal"
    }, with_trial && /*#__PURE__*/React.createElement("p", {
      className: "cancel_anytime_btn"
    }, "Cancel online anytime"), /*#__PURE__*/React.createElement("div", {
      className: "with_legal with_legal_spaced"
    }, !no_legal && legal_before_btn && /*#__PURE__*/React.createElement(Legal, _extends({}, rest, {
      with_trial: with_trial
    })), children, !no_legal && !legal_before_btn && /*#__PURE__*/React.createElement(Legal, _extends({}, rest, {
      with_trial: with_trial
    }))));
  };
  class Paypal_payment_api extends Pure_component {
    constructor(...args) {
      super(...args);
      _defineProperty(this, "state", {
        paypal_form_rendered: false
      });
    }
    componentDidUpdate() {
      if (this.props.api.loaded && !this.state.paypal_form_rendered && !this.rendering_paypal_form) {
        this.render_paypal_form();
      }
    }
    componentDidMount() {
      if (this.props.api.loaded) this.render_paypal_form();
    }
    get_paypal_plan_o(plan) {
      var c = (this.props.currency || 'USD').toLowerCase();
      var env = this.props.api.test_env ? 'test' : 'live';
      var plan_id_k = {
        test: 'paypal_test_id',
        live: 'paypal_id'
      }[env];
      if (c != 'usd' && plan.currency && plan.currency[c] && plan.currency[c][plan_id_k]) {
        return {
          id: plan.currency[c][plan_id_k],
          currency: c
        };
      }
      return {
        id: plan[plan_id_k],
        currency: c
      };
    }
    render_paypal_form() {
      var props = this.props;
      var sbx = props.api.test_env;
      var env = sbx ? 'test' : 'live';
      if (!props.api.use_paypal_api) return;
      this.rendering_paypal_form = true;
      var _this = this;
      var validate_email = () => {
        if (this.props.user || this.props.email && !this.props.email_error) return true;
        this.props.set_email_err(this.props.email_error || empty_email_err);
      };
      etask(function* () {
        this.finally(() => {
          _this.rendering_paypal_form = false;
        });
        try {
          var client_id = _.get(hopt, `paypal.${env}.client_id`);
          yield wait_for_download_scripts();
          var paypal = yield payutils.load_script('https://www.paypal.com/sdk/js?client-id=' + client_id + '&vault=true&disable-funding=credit' + '&intent=subscription', 'paypal', props.on_script_load_err);
          var opt, plan_o;
          paypal.Buttons({
            style: {
              layout: 'horizontal',
              label: 'pay',
              tagline: false,
              size: 'responsive'
            },
            onClick: (data, actions) => {
              plan_o = null;
              if (!validate_email()) return void actions.reject();
              return new Promise((resolve, reject) => {
                etask(function* () {
                  var ch_res = props.check_email(props.get_email());
                  if (!ch_res) {
                    opt = '';
                    resolve();
                    return;
                  }
                  opt = yield props.before_payment('paypal', 'api');
                  resolve(opt);
                });
              }).then(() => {
                if (!opt) return actions.reject();
                perr({
                  id: 'www_premium_payment_submit_clicked_paypal2'
                });
                plan_o = _this.get_paypal_plan_o(opt.plan);
                if (!plan_o.id) {
                  perr({
                    id: 'www_premium_payment_paypal2_rejected',
                    info: opt
                  });
                  return actions.reject();
                }
                return actions.resolve();
              });
            },
            createSubscription: (data, actions) => {
              if (!plan_o) return;
              return actions.subscription.create({
                plan_id: plan_o.id
              });
            },
            onApprove: (data, actions) => etask(function* () {
              try {
                var subscr_id = data.subscriptionID;
                plus_util.set_payment_cookie(opt.user, opt.plan, 'paypal2');
                var res = yield etask.all([$.post('/users/payment/paypal_subscription', assign({}, opt, {
                  subscr_id,
                  currency: plan_o.currency,
                  sbx,
                  site: _.get(hopt, `paypal.${env}.site`)
                }, plus_util.get_custom_opt())), perr({
                  id: 'www_premium_payment_submit_paypal2',
                  info: {
                    hola_uid: opt.user.hola_uid,
                    period: opt.plan.period,
                    plan_id: opt.plan.id,
                    subscr_id
                  }
                })]);
                res = res && res[0];
                var email = res && res.email;
                location.href = plus_util.after_payment_page(assign({
                  gateway: 'paypal',
                  email
                }, opt));
              } catch (e) {
                if (sbx) console.error(e);
                _this.setState(v => _objectSpread(_objectSpread({}, v), {}, {
                  error: e.responseText
                }));
                perr({
                  id: 'www_premium_payment_submit_failed_paypal2',
                  info: {
                    err: zerr.e2s(e),
                    opt
                  }
                });
              }
            }),
            onCancel: (data, actions) => {
              perr({
                id: 'www_premium_payment_paypal2_cancel',
                info: opt
              });
              props.after_payment();
            }
          }).render('#paypal-button-container');
          _this.setState({
            paypal_form_rendered: true
          });
        } catch (e) {
          if (sbx) console.error(e);
          perr({
            id: 'www_premium_payment_paypal2_init_err',
            info: {
              err: zerr.e2s(e)
            }
          });
        }
      });
    }
    render() {
      var is_hola2023 = this.context.theme_name != 'default';
      var need_block = experiment_init.ui_test.test_email_checkout && !this.props.user && !this.props.email;
      var paypal_cls = cn(need_block && 'block_overlay', 'paypal-button-container', this.props.legal_before_btn && 'paypal-btn-after-legal');
      return /*#__PURE__*/React.createElement("div", {
        className: 'step-payment-item paypal' + (this.props.show ? '' : ' hidden')
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.state.error && /*#__PURE__*/React.createElement("div", {
        className: "error_payment_result"
      }, this.state.error), this.props.show && /*#__PURE__*/React.createElement(Fragment, null, !this.props.user && is_hola2023 && /*#__PURE__*/React.createElement(Input, {
        cl: "paypal-email-field",
        onKeyDown: this.props.on_email_key_down,
        auto_focus: true,
        on_change_validation: false,
        name: "email",
        auto_complete: "email",
        value: this.props.email,
        validator: plus_util.email_validator,
        inputmode: "email",
        placeholder: "name@example.com",
        label: "Email",
        on_validation: this.props.set_email_err,
        error: this.props.email_error,
        on_change: this.props.set_email
      }), !this.props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, this.props, {
        id: "paypal2_promo"
      }))), this.props.before_btn_component, this.props.legal_before_btn && /*#__PURE__*/React.createElement(Legal, this.props), /*#__PURE__*/React.createElement("div", {
        id: "paypal-button-container",
        className: paypal_cls,
        onClick: ev => {
          if (need_block) {
            if (!this.props.email_error) this.props.set_email_err(empty_email_err);
            ev.stopPropagation();
            return;
          }
        }
      }), !this.props.legal_before_btn && /*#__PURE__*/React.createElement(Legal, this.props)));
    }
  }
  _defineProperty(Paypal_payment_api, "contextType", Settings_context);
  var Other_pms = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "inline-block other"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('alipay.svg'),
      alt: "alipay",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('giropay.svg'),
      alt: "giropay",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('sofort.svg'),
      alt: "sofort",
      className: "lazyload"
    }));
  };
  var BLUESNAP_FALLBACK_ERROR_CODES = zutil.bool_lookup(['ETIMEDOUT', 'INSUFFICIENT_FUNDS', 'GENERAL_PROVIDER_ERROR']);
  var bluesnap_avangate_fallback_cond = e => {
    var _e$hola_info;
    if (((_e$hola_info = e.hola_info) === null || _e$hola_info === void 0 ? void 0 : _e$hola_info.status) == 403) return false;
    return !e.reason_code || BLUESNAP_FALLBACK_ERROR_CODES[e.reason_code];
  };
  var Already_premium_warning = ({
    user,
    already_plus_err,
    children,
    on_toggle_premium_warning
  }) => {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmed = _useState2[0],
      set_confirmed = _useState2[1];
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      show_warning = _useState4[0],
      set_show_warning = _useState4[1];
    var _useContext3 = useContext(App_context),
      is_plus = _useContext3.is_plus,
      is_ultra = _useContext3.is_ultra;
    if (confirmed || !(user && user.already_plus || is_plus || is_ultra || already_plus_err)) {
      if (show_warning) {
        if (on_toggle_premium_warning) on_toggle_premium_warning(false);
        set_show_warning(false);
      }
    } else if (!show_warning) {
      if (on_toggle_premium_warning) on_toggle_premium_warning(true);
      set_show_warning(true);
    }
    if (!show_warning) return children;
    return /*#__PURE__*/React.createElement("div", {
      className: "already_plus",
      role: "alert"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "already_plus_title"
    }, "You are already subscribed to Hola Premium."), /*#__PURE__*/React.createElement("p", {
      className: "already_plus_text"
    }, "Continue to change your current plan"), /*#__PURE__*/React.createElement("button", {
      className: "hola_btn hola_btn--round",
      onClick: () => set_confirmed(true)
    }, /*#__PURE__*/React.createElement("span", null, "Continue")), /*#__PURE__*/React.createElement("p", {
      className: "already_plus_help"
    }, "Need help? Check out our", ' ', /*#__PURE__*/React.createElement(RRD.Link, {
      className: "hola_link",
      to: "/support"
    }, "help center")));
  };
  var Avangate_payment = props => {
    var is_hola2023 = props.theme_name != 'default';
    var submitting = props.submitting && props.last_submit_is('avangate');
    var btn_cls = cn('hola_btn hola_btn--round hola_btn--w100', submitting && 'submitting');
    return /*#__PURE__*/React.createElement("div", {
      className: 'step-payment-item other ' + (props.show ? '' : ' hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, !props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "avangate_promo"
    })), props.before_btn_component, is_hola2023 ? /*#__PURE__*/React.createElement(With_legal, props, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      disabled: submitting,
      arrow: true,
      caption: props.submit_caption,
      cls: "submit_btn",
      on_click: () => props.submit_avangate(),
      tab_index: "38"
    }), props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "avangate_promo"
    })))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      disabled: submitting,
      onClick: () => props.submit_avangate(),
      tabIndex: "38"
    }, /*#__PURE__*/React.createElement("span", null, "Continue")), !props.no_legal && /*#__PURE__*/React.createElement(Legal, props))));
  };
  var twopay_styles = {
    margin: 0,
    fontFamily: `'Montserrat',sans-serif`,
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '16px',
    color: '#40474f',
    textAlign: 'left',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    '*': {
      'boxSizing': 'border-box'
    },
    '.form': {
      display: 'flex',
      flexWrap: 'wrap'
    },
    '.row': {
      display: 'flex',
      flexWrap: 'wrap'
    },
    'div': {
      display: 'block'
    },
    '.card-number': {
      width: '310px',
      marginRight: '16px'
    },
    '.card-number .input-wrapper': {
      position: 'relative'
    },
    '.card-expiration-date': {
      width: '110px',
      marginRight: '16px'
    },
    '.card-security-code': {
      width: '100px'
    },
    label: {
      display: 'inline-block',
      marginBottom: '8px',
      color: '#73757a;',
      fontFamily: `'Montserrat', sans-serif`,
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      whiteSpace: 'nowrap'
    },
    'input': {
      overflow: 'visible',
      margin: 0,
      font: 'inherit',
      display: 'block',
      width: '100%',
      height: '44px',
      paddingLeft: '16px !important',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      color: '#40474f',
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
      border: '1px solid #65707c',
      borderRadius: '8px',
      transition: 'border-color .15s ease-in-out,box-shadow .15s ' + 'ease-in-out',
      outline: 0
    },
    '.card-number .is-empty input': {
      paddingLeft: '42px !important'
    },
    '.card-number .is-focused input': {
      paddingLeft: '16px !important'
    },
    'input::placeholder': {
      color: '#a3b5ca !important',
      fontWeight: 500
    },
    'input:placeholder-shown': {
      border: '1px solid #a3b5ca'
    },
    'input:focus': {
      border: '1px solid #ff6400'
    },
    '.is-error input': {
      border: '1px solid #f44831'
    },
    '.validation-message': {
      color: '#f44831',
      fontSize: '11px',
      lineHeight: '11px'
    },
    '.lock-icon': {
      display: 'none'
    },
    '.valid-icon': {
      display: 'none'
    },
    '.error-icon': {
      display: 'none'
    },
    '.card-icon': {
      position: 'absolute',
      left: '10px',
      top: '11px'
    },
    '.card-type-icon': {
      position: 'absolute',
      right: '10px',
      top: '7px'
    }
  };
  var hola2023_twopay_styles = {
    margin: 0,
    textAlign: 'left',
    fontFamily: 'sans-serif',
    backgroundColor: 'transparent',
    overflow: 'hidden',
    '*': {
      'boxSizing': 'border-box'
    },
    'div': {
      display: 'block'
    },
    '.form': {
      display: 'flex',
      flexWrap: 'wrap',
      flexGap: '24px'
    },
    '.row': {
      display: 'flex',
      flexWrap: 'nowrap',
      flex: '1',
      gap: '24px'
    },
    '.col': {
      display: 'flex',
      flexWrap: 'nowrap',
      flex: '1'
    },
    '.card-number': {
      flexBasis: '303px',
      minWidth: '212px',
      marginRight: '24px',
      marginBottom: '32px'
    },
    '.card-expiration-date': {
      flexBasis: '140px',
      minWidth: '112px',
      marginRight: '24px',
      minHeight: '99px'
    },
    '.card-security-code': {
      flexBasis: '140px',
      minWidth: '112px',
      marginRight: '24px'
    },
    '.card-icon': {
      display: 'none'
    },
    '.card-type-icon': {
      display: 'none'
    },
    '.lock-icon': {
      display: 'none'
    },
    '.valid-icon': {
      display: 'none'
    },
    '.error-icon': {
      display: 'none'
    },
    'input': {
      width: '100%',
      display: 'block',
      outline: 'none',
      height: '48px',
      padding: '12px 16px !important',
      fontFamily: 'sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '24px',
      letterSpacing: 'normal',
      color: '#32302F',
      backgroundColor: '#FAFAFA',
      backgroundClip: 'padding-box',
      border: '1px solid #E9E8E8',
      borderRadius: '4px',
      transition: 'border-color ease-in-out .15s,' + 'box-shadow ease-in-out .15s'
    },
    'input::placeholder': {
      fontFamily: 'sans-serif',
      color: '#7D7D7D !important',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '24px',
      letterSpacing: 'normal'
    },
    'input:placeholder-shown': {
      border: '1px solid #E9E8E8'
    },
    'input:placeholder-shown:not(:focus)': {
      backgroundColor: '#F5F5F5'
    },
    'input:focus': {
      borderColor: '#ABABAB'
    },
    '.is-error input': {
      border: '1px solid #e37278',
      color: '#e37278'
    },
    '.is-error input:placeholder-shown': {
      border: '1px solid #e37278',
      backgroundColor: '#FAFAFA'
    },
    '.is-error input::placeholder': {
      color: '#e37278 !important'
    },
    '.field-container': {
      position: 'relative'
    },
    '.validation-message': {
      color: '#e37278',
      fontSize: '11px',
      fontWeight: '400',
      letterSpacing: '0.01em',
      lineHeight: '1.36',
      display: 'block',
      marginTop: '4px',
      position: 'absolute'
    },
    label: {
      display: 'block',
      marginBottom: '4px',
      color: '#7D7D7D',
      fontSize: '11px',
      fontWeight: '500',
      lineHeight: '1.36',
      letterSpacing: '0.01em'
    }
  };
  var countries = _difference(Object.keys(zcountry.iso_list), zcountry.avangate_prohibited_countries).map(c => {
    return {
      value: c,
      title: c,
      full_title: `${c} - ${zcountry.isocode2country(c)}`
    };
  });
  var in_states = Object.keys(zcountry.in_state_list).map(c => {
    return {
      value: c,
      title: c,
      full_title: `${c} - ${zcountry.in_state_list[c]}`
    };
  });
  var cc_2checkout_submitting, cc_2checkout_inited;
  var CC_2checkout = props => {
    var is_hola2023 = props.theme_name != 'default';
    var submit_payment = props.submit_payment,
      user = props.user,
      plan = props.plan,
      currency = props.currency,
      email = props.email,
      input_small = props.input_small,
      hidden_checkout = props.hidden_checkout;
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      client = _useState6[0],
      set_client = _useState6[1];
    var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      vat_et = _useState8[0],
      set_vat_et = _useState8[1];
    var _useState9 = useState({
        name: '',
        state: hopt.user_country == 'IN' ? Object.keys(zcountry.in_state_list)[0] : '',
        country: hopt.user_country,
        zip: ''
      }),
      _useState0 = _slicedToArray(_useState9, 2),
      st = _useState0[0],
      set_st = _useState0[1];
    var _useState1 = useState(false),
      _useState10 = _slicedToArray(_useState1, 2),
      loading = _useState10[0],
      set_loading = _useState10[1];
    var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      inited = _useState12[0],
      set_inited = _useState12[1];
    var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      full_err = _useState14[0],
      set_full_err = _useState14[1];
    var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      err_msg = _useState16[0],
      set_err_msg = _useState16[1];
    var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      component = _useState18[0],
      set_component = _useState18[1];
    var _useContext4 = useContext(Settings_context),
      theme = _useContext4.theme;
    var submitting = props.submitting && props.last_submit_is('avangate', '2pay') || loading;
    cc_2checkout_submitting = submitting;
    cc_2checkout_inited = inited;
    useEffect(() => {
      var init_err, mount_timer;
      var styles = is_hola2023 ? hola2023_twopay_styles : twopay_styles;
      var mount = () => {
        client = new window.TwoPayClient('HOLANETW');
        set_client(client);
        component = client.components.create('card', styles);
        component.mount('#card-element');
        set_component(component);
        perr({
          id: 'www_premium_payment_avangate_2pay_init',
          info: {
            details: get_details()
          }
        });
      };
      var init_timer = setTimeout(() => {
        clearInterval(mount_timer);
        props.set_fallback_route([['cc', 'avangate', '2pay'], ['cc', 'bluesnap', plus_util.api.bs_def], ['cc', 'stripe', 'api']]);
        perr({
          id: 'www_premium_payment_avangate_2pay_init_timeout',
          info: {
            err: init_err,
            details: get_details()
          }
        });
      }, _.get(hopt, 'www_hola.payment.avangate.twopay.init_timeout', 5) * SEC);
      var detect_iframe_load = ev => {
        if (!(/2pay-js/.test(ev.origin) && /update:height/.test(ev.data))) return;
        clearTimeout(init_timer);
        if (!inited && init_timer) {
          perr({
            id: 'www_premium_payment_avangate_2pay_inited',
            info: {
              details: get_details()
            }
          });
        }
        set_inited(true);
        props.on_load && props.on_load();
        init_timer = null;
      };
      mount_timer = setInterval(() => {
        try {
          mount();
          clearInterval(mount_timer);
          init_err = null;
        } catch (e) {
          init_err = zerr.e2s(e);
        }
      }, _.get(hopt, 'www_hola.payment.avangate.twopay.init_interval', 0.1) * SEC);
      window.addEventListener('message', detect_iframe_load);
      var on_submit_requested = event => {
        if (event.state.provider == 'avangate') submit();
      };
      E.emitter.on('submit_requested', on_submit_requested);
      return () => {
        clearInterval(mount_timer);
        window.removeEventListener('message', detect_iframe_load);
        E.emitter.removeListener('submit_requested', on_submit_requested);
      };
    }, []);
    useEffect(() => {
      var product_id = zutil.get(plan, 'net.avangate_product');
      var avg_conf = zutil.get(plus_util.test, 'cc_payment.avangate', {});
      if (!product_id || !avg_conf || !(avg_conf.vat_on || avg_conf.vat_1m1y && plan.period != '3 Y')) {
        return void props.unset_vat_obj();
      }
      var _get_details = get_details(),
        country = _get_details.country,
        state = _get_details.state,
        zip = _get_details.zip;
      if (vat_et) vat_et.return();
      props.set_vat_loading();
      set_vat_et(etask(function* () {
        this.catch(e => {
          props.unset_vat_obj();
          perr({
            id: 'www_premium_payment_get_vat_err',
            info: {
              err: zerr.e2s(e),
              provider: 'avangate'
            }
          });
        });
        var res = yield plus_util.get_vat('avangate', {
          product_id,
          currency,
          country,
          state,
          zip
        });
        props.set_vat_obj(res);
      }));
    }, [plan.id, currency, st.country, st.state, st.zip]);
    var btn_cls = cn('hola_btn hola_btn--round hola_btn--w100', submitting && 'submitting', hidden_checkout && 'hidden_checkout');
    var set_err = (err, type) => {
      var msg = (typeof err == 'string' ? err : err && err.pub_reason) || (('' + err).includes('Form data is invalid') ? 'Form is invalid. Please check for required fields' : plus_util.generic_err);
      set_err_msg(msg);
      perr({
        id: 'www_premium_payment_submit_failed_avangate',
        info: {
          msg,
          err: zerr.e2s(err),
          err_type: type,
          payment_type: '2pay',
          details: get_details()
        }
      });
    };
    var get_details = () => {
      var details = {
        country: st.country,
        name: ('' + (st.name || '')).trim(),
        email: props.get_email()
      };
      if (st.country == 'US') {
        assign(details, {
          zip: st.zip,
          state: st.zip && zcountry.get_state_by_zip(st.zip)
        });
      }
      if (st.country == 'IN') details.state = st.state;
      return details;
    };
    var immutable_root = useRef({});
    var do_submit = event => {
      if (event && event.preventDefault) event.preventDefault();
      if (cc_2checkout_submitting || !cc_2checkout_inited) return;
      var details = get_details();
      perr({
        id: 'www_premium_payment_submit_clicked_avangate',
        info: {
          payment_type: '2pay',
          details
        }
      });
      if (!client || !component) {
        return void perr({
          id: 'www_premium_payment_avangate_2pay_not_inited',
          info: {
            details
          }
        });
      }
      set_err_msg('');
      set_loading(true);
      client.tokens.generate(component, details).then(response => {
        etask(function* () {
          this.finally(() => {
            set_loading(false);
            props.after_payment();
          });
          this.catch(e => set_err(e, 'unexpected'));
          if (!validate()) return;
          var res = yield submit_payment('avangate_2pay', assign({
            token: response.token
          }, details));
          if (!res) throw new Error('Empty response');
          if (res.Errors && res.Errors.length) {
            return void set_err(res.Errors.find(Boolean), 'api_response');
          }
          location.href = plus_util.after_payment_page({
            email: details.email,
            trans: res.RefNo,
            gateway: 'avangate'
          });
        });
      }).catch(e => {
        set_loading(false);
        props.after_payment();
        if (!validate()) return;
        set_err(e, 'failed_generate_token');
        perr({
          id: 'www_premium_payment_avangate_2pay_err',
          info: {
            err: zerr.e2s(e),
            details
          }
        });
      });
    };
    immutable_root.current.do_submit = do_submit;
    var submit = event => {
      return immutable_root.current.do_submit(event);
    };
    var on_change_name = v => set_st(_objectSpread(_objectSpread({}, st), {}, {
      name: v,
      name_err: 0
    }));
    var on_change_zip = ev => set_st(_objectSpread(_objectSpread({}, st), {}, {
      zip: ev.target.value,
      zip_err: 0
    }));
    var on_change_country = (field, country) => {
      var new_state = _objectSpread({}, st);
      if (country == 'UK') country = 'GB';
      if (country == 'IN' && !st.state) new_state.state = Object.keys(zcountry.in_state_list)[0];
      set_st(_objectSpread(_objectSpread({}, new_state), {}, {
        country,
        country_err: 0
      }));
      perr({
        id: `www_premium_fill_country`,
        info: {
          details: get_details()
        }
      });
    };
    var on_change_state = (field, state) => {
      set_st(st_ => _objectSpread(_objectSpread({}, st_), {}, {
        state,
        state_err: 0
      }));
    };
    var validate = kind => {
      var valid = true;
      var ext_st = {};
      if (!kind && !props.user && (!email || props.email_error)) {
        props.set_email_err(props.email_error || empty_email_err);
        valid = false;
      }
      if (!kind || kind == 'name') {
        var name = ('' + (st.name || '')).trim();
        if (!name) {
          valid = false;
          if (!st.name_err) ext_st.name_err = 1;
        }
      }
      if ((!kind || kind == 'zip') && st.country == 'US' && !zcountry.get_state_by_zip(st.zip)) {
        valid = false;
        if (!st.zip_err) ext_st.zip_err = 1;
      }
      if ((!kind || kind == 'state') && st.country == 'IN' && !st.state) {
        valid = false;
        if (!st.state_err) ext_st.state_err = 1;
      }
      set_st(_objectSpread(_objectSpread({}, st), ext_st));
      return valid;
    };
    var add_field = {
      US: 1,
      BR: 1,
      IN: 1
    }[st.country];
    var show_extra_field = {
      US: 1,
      IN: 1
    }[st.country];
    var input_label_cls = !is_hola2023 && cn(theme.xs, theme.logo_grey);
    var show_country = !props.hide_country || {
      US: 1,
      IN: 1
    }[st.country];
    var show_email = props.email_in_cc && !(user !== null && user !== void 0 && user.emails);
    return /*#__PURE__*/React.createElement("div", {
      className: 'step-payment-item other ' + (props.show ? '' : ' hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('form-holder', !inited && 'initializing')
    }, !inited && props.with_skeleton && /*#__PURE__*/React.createElement(Card_skeleton, {
      abs: true
    }), submitting && /*#__PURE__*/React.createElement("div", {
      className: "form-overlay"
    }), /*#__PURE__*/React.createElement("div", {
      id: "card-element",
      className: cn(is_hola2023 && 'hola2023')
    }), inited && /*#__PURE__*/React.createElement("div", {
      className: cn('ccard_with_email twopay', is_hola2023 && 'hola2023')
    }, /*#__PURE__*/React.createElement(Input, {
      cl: cn('ccard_holder_name_field', show_email ? is_hola2023 ? 'field_name no_user' : 'cc_w_268' : is_hola2023 ? 'field_name is_user' : 'cc_w_100w'),
      size: input_small && !is_hola2023 ? 'sm' : undefined,
      on_change_validation: false,
      no_margin: true,
      name: "name",
      auto_complete: "cc-name",
      value: st.name,
      validator: v => !v,
      placeholder: "Full name",
      label: "Name on card",
      on_validation: err => set_st(_objectSpread(_objectSpread({}, st), {}, {
        name_err: err
      })),
      error: st.name_err && 'Invalid name',
      on_change: on_change_name,
      onKeyDown: ({
        key
      }) => key == 'Enter' && submit()
    }), show_email && /*#__PURE__*/React.createElement(Input, {
      cl: cn('email_field', is_hola2023 ? 'field_email' : 'cc_w_268'),
      size: input_small && !is_hola2023 ? 'sm' : undefined,
      onKeyDown: props.on_email_key_down,
      no_margin: true,
      on_change_validation: false,
      name: "email",
      auto_complete: "email",
      value: email,
      validator: plus_util.email_validator,
      inputmode: "email",
      placeholder: "name@example.com",
      label: "Email",
      on_validation: props.set_email_err,
      error: props.email_error,
      on_change: props.set_email
    }), show_country && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: cn('form_field country_field', is_hola2023 ? 'field_country' : 'cc_w_268', show_extra_field ? 'with_field' : 'no_field')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Country"), /*#__PURE__*/React.createElement(Select, {
      items: countries,
      name: "country",
      on_select: on_change_country,
      value: st.country,
      class_name: "countries_select",
      expand: "left"
    }), !!st.country_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid country")), add_field && /*#__PURE__*/React.createElement(Fragment, null, st.country == 'US' && /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', 'zip_field', st.zip_err && 'invalid', is_hola2023 ? 'field_zip' : 'cc_w_268')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Postal code"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: cn('hola_input', input_small && 'hola_input--sm'),
      name: "zip",
      value: st.zip,
      placeholder: " ",
      autoComplete: "postal-code",
      onChange: on_change_zip,
      onBlur: () => validate('zip')
    }), !!st.zip_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid postal code")), st.country == 'IN' && /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', 'state_field', st.state_err && 'invalid', is_hola2023 ? 'field_state' : 'cc_w_268')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "State"), /*#__PURE__*/React.createElement(Select, {
      items: in_states,
      name: "state",
      on_select: on_change_state,
      value: st.state,
      class_name: "countries_select"
    }), !!st.state_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid state")))), err_msg && /*#__PURE__*/React.createElement("div", {
      className: "row pay-err"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert alert-danger"
    }, /*#__PURE__*/React.createElement("div", {
      className: ('' + err_msg).length > 200 && !full_err ? 'long-err' : '',
      onClick: () => set_full_err(!full_err),
      dangerouslySetInnerHTML: {
        __html: err_msg
      }
    })))))), inited && /*#__PURE__*/React.createElement(Fragment, null, !props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "cc_2checkout_promo"
    })), is_hola2023 ? /*#__PURE__*/React.createElement(With_legal, props, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      disabled: submitting,
      arrow: true,
      caption: props.submit_caption,
      cls: "submit_btn",
      on_click: submit,
      tab_index: "38"
    }), props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "cc_2checkout_promo"
    })))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      onClick: submit,
      disabled: submitting,
      tabIndex: "38"
    }, submitting && /*#__PURE__*/React.createElement(Spinner, null), !submitting && /*#__PURE__*/React.createElement("span", null, "Place your order")), !props.no_legal && /*#__PURE__*/React.createElement(Legal, props)))));
  };
  var skeleton_first = window._the_first_js_data || 0;
  var Card_skeleton = props => {
    var _useContext5 = useContext(Callback_context),
      callbacks = _useContext5.callbacks;
    var _useState19 = useState(skeleton_first > 0 ? Date.now() - skeleton_first >= 2000 : false),
      _useState20 = _slicedToArray(_useState19, 2),
      is_visible_animation = _useState20[0],
      set_is_visible_animation = _useState20[1];
    useEffect(() => {
      clearTimeout(window.skeleton_loading_timeout);
      if (skeleton_first === 0) skeleton_first = Date.now();
      if (callbacks.fn && callbacks.fn.add) callbacks.fn.add(Date.now() - skeleton_first >= 2000);
      var timeout_value = 2000 - (Date.now() - skeleton_first);
      var show_timeout;
      if (timeout_value > 0) {
        show_timeout = setTimeout(() => {
          if (callbacks.fn && callbacks.fn.add) callbacks.fn.add(true);
          set_is_visible_animation(true);
        }, timeout_value);
      }
      return () => {
        if (callbacks.fn) callbacks.fn.remove();
        clearTimeout(show_timeout);
      };
    }, []);
    return /*#__PURE__*/React.createElement("div", {
      className: cn('step-payment-item other', props.abs && 'skeleton_form_abs', is_visible_animation && 'skeleton_not_null_opacity', 'skeleton_full_form'),
      id: 'skeleton_form'
    }, /*#__PURE__*/React.createElement("p", {
      className: cn('skeleton_title', is_visible_animation && 'visible_title'),
      id: 'skeleton_loading_title'
    }, "Loading..."), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_form_top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_after skeleton_w_100"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_just"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('form-holder')
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('ccard_with_email twopay hola2023')
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation field_number"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation field_exp"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation field_cvv"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation field_email"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation field_email"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation skeleton_animation_cta"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w172"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w320"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w100p"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w100p"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w100p"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w180"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "skeleton_textline w90p"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "skeleton_animation_gradient"
    }))))));
  };
  var CC_bluesnap_hpf = props => {
    var GET = 0,
      SET = 1;
    var _useContext6 = useContext(Settings_context),
      theme = _useContext6.theme,
      theme_name = _useContext6.theme_name;
    var is_hola2023 = theme_name != 'default';
    var tags = {
      ccn: {
        focus: useState(false),
        empty: useState(true),
        error: useState(false)
      },
      exp: {
        focus: useState(false),
        empty: useState(true),
        error: useState(false)
      },
      cvv: {
        focus: useState(false),
        empty: useState(true),
        error: useState(false)
      }
    };
    var _useState21 = useState({
        inited: false,
        loading: false,
        card_brand: undefined,
        name_err: false,
        show_fp: false,
        fp_shown: false,
        fallback_plan: false,
        err_msg: '',
        name: '',
        i: 0
      }),
      _useState22 = _slicedToArray(_useState21, 2),
      st = _useState22[0],
      set_st = _useState22[1];
    var update_st = new_st => {
      new_st = _objectSpread(_objectSpread({}, st_ref.current), new_st);
      st_ref.current = new_st;
      set_st(new_st);
    };
    var st_ref = useRef();
    st_ref.current = st;
    var props_ref = useRef();
    props_ref.current = props;
    var refs = {
      ccn: useRef(),
      exp: useRef(),
      cvv: useRef()
    };
    var is_submitting = () => props_ref.current.submitting && props.last_submit_is('bluesnap', 'hpf') || st_ref.current.loading;
    var submitting = is_submitting();
    var btn_cls = cn('hola_btn hola_btn--round hola_btn--w100', submitting && 'submitting', props.hidden_checkout && 'hidden_checkout');
    var get_perr_info = () => {
      var plan = props_ref.current.plan || {};
      var currency = zmembership.get_plan_currency(plan, props_ref.current.currency);
      var price_plan = zmembership.get_price_plan(plan, currency);
      return {
        email: props.get_email(),
        name: st_ref.current.name,
        gateway: 'bluesnap',
        hola_uid: props.get_hola_uid(),
        hola_plan_id: plan.id,
        period: plan.period,
        plan_id: plus_util.get_bluesnap_plan_id(plan, currency),
        price: price_plan.price,
        currency,
        sbx: props.api.test_env
      };
    };
    var _perr = (id, info) => perr({
      id,
      info: assign(get_perr_info(), info)
    });
    var show_fallback_promo = fp => {
      test_log('fallback_plan', fp);
      var plan = props.plan,
        plans = props.plans;
      var fps = [fp];
      plans_util.activate_discount_plans(fps, plans);
      var ids = plans_util.merge_plans(plans, fps);
      props.set_plans(_.values(plans_util.get_plans_info(ids)));
      props.set_plan(plan);
      update_st({
        show_fp: true,
        fp_shown: true,
        fallback_plan: fp
      });
      _perr('www_premium_fallback_promo');
      return true;
    };
    var on_close_fp = () => {
      update_st({
        show_fp: false,
        fp_shown: true,
        fallback_plan: false
      });
    };
    var test_show_fp = () => {
      var plan = props_ref.current.plan || {};
      if (!st_ref.current.fp_shown) {
        var fp = plans_util.get_plan_info(plan.fallback_plan);
        fp && show_fallback_promo(fp);
      }
    };
    var set_err = err => {
      zerr('bluesnap error %O', err);
      if (err.error == 'invalid_email') return;
      var plan = props_ref.current.plan || {};
      var fp;
      if (plus_util.test.fallback_promo && !st_ref.current.fp_shown && (qs_o().debug_fallback_promo || err.reason_code == 'INSUFFICIENT_FUNDS') && (fp = plan.fallback_plan)) {
        fp = plans_util.get_plan_info(fp);
        if (fp && show_fallback_promo(fp)) return;
      }
      if (st_ref.current.fp_shown) on_close_fp();
      if (qs_o().debug_suspect_dlg) susp_dlg('bluesnap_susp', is_hola2023);
      if (!props.avangate_fallback_if || !props.avangate_fallback_if(bluesnap_avangate_fallback_cond(err), plus_util.get_err_text(err))) {
        err_dlg('bluesnap', is_hola2023, theme_name);
      }
      var msg = err.pub_reason || plus_util.generic_err;
      // set_err_msg(msg);
      _perr('www_premium_payment_submit_failed_bluesnap', assign({
        msg,
        err: err && err.stack || zerr.e2s(err)
      }, _.omit(err, ['subscr'])));
    };
    var submit = (event, opt) => {
      if (event && event.preventDefault) event.preventDefault();
      if (props.purchase_disabled) return;
      if (is_submitting() || !st_ref.current.inited) return;
      if (props.before_payment) props.before_payment();
      _perr('www_premium_payment_submit_clicked_bluesnap', assign({
        payment_type: 'hpf',
        name: st_ref.current.name
      }));
      send_submit_event();
      var invalid;
      if (!props_ref.current.user && (!props_ref.current.email || props_ref.current.email_error)) {
        props.set_email_err(props_ref.current.email_error || empty_email_err);
        invalid = true;
      }
      if (!validate_name(st_ref.current.name, false)) invalid = true;
      update_st({
        loading: true,
        err_msg: ''
      });
      try {
        var currency = zmembership.get_plan_currency(props_ref.current.plan, props_ref.current.currency);
        var price_plan = zmembership.get_price_plan(props_ref.current.plan, currency);
        var three_ds_obj = {
          amount: price_plan.price,
          currency
        };
        test_log('three_ds_obj', three_ds_obj);
        bluesnap.hostedPaymentFieldsSubmitData(cb => etask(function* () {
          try {
            var _pay_ccardbs$_env$loa;
            test_log('cb', cb);
            if (cb.cardData == null) {
              var err_arr = cb.error;
              for (var i in err_arr) tags[err_arr[i].tagId].error[SET](true);
              invalid = true;
            }
            if (invalid) {
              if (props.on_submit_err) props.on_submit_err();
              return void update_st({
                loading: false
              });
            }
            var fraud_session_id = cb.transactionFraudInfo.fraudSessionId;
            var three_ds = cb.threeDSecure;
            var cd = cb.cardData;
            var ccard_type = ('' + cd.ccType).toLowerCase();
            var three_ds_ref_id = three_ds === null || three_ds === void 0 ? void 0 : three_ds.threeDSecureReferenceId;
            test_log('three_ds_ref_id', three_ds_ref_id);
            yield props.submit_payment('bluesnap_hpf', {
              pf_token: (_pay_ccardbs$_env$loa = pay_ccardbs._env.loaded) === null || _pay_ccardbs$_env$loa === void 0 ? void 0 : _pay_ccardbs$_env$loa.pf_token,
              fraud_session_id,
              three_ds_ref_id,
              ccard_country: ('' + cd.issuingCountry).toUpperCase(),
              ccard_type,
              ccard_lbl: (ccard_type[0] || '').toUpperCase() + ccard_type.slice(1) + ' *' + cd.last4Digits,
              ccard_bank: cd.ccIssuingBank,
              ccard_sub_type: ('' + cd.cardSubType).toLowerCase(),
              ccard_bin: cd.ccBin,
              ccard_bin_category: cd.binCategory,
              ccard_category: cd.cardCategory,
              ccard_holder: st_ref.current.name,
              ccard_exp: cd.exp,
              three_ds_auth_result: three_ds === null || three_ds === void 0 ? void 0 : three_ds.authResult,
              quantity: props_ref.current.quantity,
              email: props_ref.current.email,
              plan: props_ref.current.plan,
              cart: props_ref.current.cart,
              bundle: props_ref.current.bundle
            });
            if (props.on_payment) return props.on_payment(null, props_ref.current.email);
          } catch (e) {
            _perr('www_premium_payment_bluesnap_err', {
              err: e && e.stack || zerr.e2s(e)
            });
            update_st({
              loading: false
            });
            set_err(e);
          }
        }), three_ds_obj);
      } catch (e) {
        if (!e.message.includes('hostedPaymentFieldsCreate was not')) update_st({
          err_msg: plus_util.generic_err
        });
        return update_st({
          loading: false
        });
      }
    };
    var on_change_name = ev => update_st({
      name: ev.target.value,
      name_err: false
    });
    var validate_name = (v, allow_empty) => {
      v = ('' + (v || '')).trim();
      if (!v && allow_empty) return true;
      update_st({
        name_err: !v
      });
      if (v) update_st({
        name: v
      });
      return !!v;
    };
    var input_label_cls = !is_hola2023 && cn(theme.xs, theme.logo_grey);
    var cc_cls = cn(props.email_in_cc ? 'ccard_with_email' : 'ccard_form', !st.inited && 'initializing', is_hola2023 && 'hola2023', props.bundle == 'toolip' && 'is_toolip');
    var tooltip_icon = is_hola2023 ? '/hola2023/icons/16/question.svg' : 'info.svg';
    useEffect(() => {
      var init_err, last_init_err, mount_timer;
      var on_submit_requested = event => {
        if (event.state.provider == 'bluesnap' && event.state.type == 'hpf') submit();
      };
      var mount = () => {
        var _pay_ccardbs$_env$loa2;
        var token = (_pay_ccardbs$_env$loa2 = pay_ccardbs._env.loaded) === null || _pay_ccardbs$_env$loa2 === void 0 ? void 0 : _pay_ccardbs$_env$loa2.pf_token;
        if (!token) throw new Error('no token');
        var bs_obj = {
          '3DS': true,
          token,
          onFieldEventHandler: {
            setupComplete: () => {
              test_log('mounted bluesnap_hpf');
              props.on_load && props.on_load();
              _perr('www_premium_payment_bluesnap_hpf_inited');
              update_st({
                inited: true
              });
            },
            threeDsChallengeExecuted: () => {
              _perr('www_premium_payment_bluesnap_3ds_executed');
            },
            onFocus: tag_id => {
              tags[tag_id].focus[SET](true);
            },
            onBlur: tag_id => {
              tags[tag_id].focus[SET](false);
            },
            onError: (tag_id, err_code, err_desc, evt_origin) => {
              if (err_desc != 'empty' || is_submitting()) {
                tags[tag_id].error[SET](true);
                update_st({
                  loading: false
                });
              } else {
                tags[tag_id].error[SET](false);
                tags[tag_id].empty[SET](true);
              }
            },
            onType: (tag_id, card_type, card_data) => {
              tags[tag_id].empty[SET](false);
              if (card_type && card_type != 'UNKNOWN') {
                var card_brand = card_type.toLowerCase();
                if (card_brand != st.card_brand) update_st({
                  card_brand
                });
              }
            },
            onEnter: tag_id => {
              submit();
            },
            onValid: tag_id => {
              tags[tag_id].error[SET](false);
            }
          },
          style: {
            input: {
              'font-family': is_hola2023 ? 'Poppins, sans-serif' : 'Montserrat, sans-serif',
              'font-weight': is_hola2023 ? '400' : '500',
              'font-size': '14px'
            },
            '::placeholder': {
              color: is_hola2023 ? '#7D7D7D' : '#A3B5CA'
            },
            '.invalid': {
              color: '#e37278'
            }
          },
          ccnPlaceHolder: '0000 0000 0000 0000',
          cvvPlaceHolder: '000',
          expPlaceHolder: 'mm/yy'
        };
        bluesnap.hostedPaymentFieldsCreate(bs_obj);
        E.emitter.on('submit_requested', on_submit_requested);
        clearTimeout(init_timer);
      };
      mount_timer = setInterval(() => {
        try {
          mount();
          clearInterval(mount_timer);
          init_err = null;
        } catch (e) {
          init_err = zerr.e2s(e);
          if (init_err != last_init_err) test_log_error('bluesnap_hpf init err', init_err);
          last_init_err = init_err;
        }
      }, _.get(hopt, 'www_hola.payment.bluesnap.hpf.init_interval', 0.1) * SEC);
      var timeout = _.get(hopt, 'www_hola.payment.bluesnap.hpf.init_timeout', 5);
      var try_n = 1;
      var init_timer = setInterval(() => {
        // try one more time if no choice
        // TODO vitaly: hide cc payment in this case
        if (!zutil.get(props, 'plan.stripe') && try_n < 2) return try_n++;
        _perr('www_premium_payment_bluesnap_hpf_init_timeout', {
          init_err,
          timeout
        });
        test_log_error('init_err', init_err);
        test_log('stop attempt to mount bluesnap_hpf');
        clearInterval(init_timer);
        clearInterval(mount_timer);
        props.set_fallback_route([['cc', 'bluesnap', 'hpf'], ['cc', 'stripe', 'api'], ['cc', 'avangate', '2pay']]);
        plus_util.no_test.cc_payment = true;
      }, timeout * SEC);
      return () => {
        clearInterval(init_timer);
        clearInterval(mount_timer);
        E.emitter.removeListener('submit_requested', on_submit_requested);
      };
    }, []);
    useEffect(() => {
      if (!st.inited || !props.plan || !props.plan.fallback_plan) return;
      if (qs_o().debug_fallback_promo) test_show_fp();
    }, [st.inited, props.plan && props.plan.fallback_plan]);
    var get_hpf_cls = id => cn(tags[id].error[GET] && 'hola_input--error', tags[id].empty[GET] && 'hola_input--placeholder', tags[id].focus[GET] && 'hola_input--focus');
    return /*#__PURE__*/React.createElement("div", {
      className: cn('step-payment-item', 'other', !props.show && 'hidden', st.inited && 'inited')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, props.with_skeleton && !st.inited && /*#__PURE__*/React.createElement(Card_skeleton, {
      abs: true
    }), /*#__PURE__*/React.createElement("div", {
      className: cc_cls
    }, submitting && /*#__PURE__*/React.createElement("div", {
      className: "form-overlay"
    }), props.email_in_cc || is_hola2023 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_number' : 'cc_w_340')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls, 'lbl--tooltip')
    }, "Card number", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cn,
      cls_cn: "cards_tooltip",
      cls: "ccard_tooltip_icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(tooltip_icon),
      className: cn('question', 'lazyload'),
      alt: "toolip_icon"
    })), props.cc_label_with_card_icons && /*#__PURE__*/React.createElement("span", {
      className: "cc_icons"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('visa.svg'),
      alt: "visa",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('mastercard_2023.svg'),
      alt: "mastercard",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('amex_2023.svg'),
      alt: "amex",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('discover.svg'),
      alt: "discover",
      className: "lazyload"
    }))), /*#__PURE__*/React.createElement("div", {
      className: cn('ccn', st.card_brand && 'with_card_brand')
    }, !is_hola2023 && st.card_brand && /*#__PURE__*/React.createElement("div", {
      className: "card_brand_icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: get_bluesnap_card_brand_icon(st.card_brand),
      alt: "bluesnap",
      className: "lazyload"
    })), /*#__PURE__*/React.createElement("div", {
      ref: refs.ccn,
      "data-bluesnap": "ccn",
      className: cn('hola_input hola_input--bluesnap_hpf', get_hpf_cls('ccn'), props.input_small && 'hola_input--sm')
    })), tags.ccn.error[GET] && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid card number")), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_exp' : 'cc_w_90')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Expiry date"), /*#__PURE__*/React.createElement("div", {
      "data-bluesnap": "exp",
      ref: refs.exp,
      className: cn('hola_input hola_input--bluesnap_hpf', get_hpf_cls('exp'), props.input_small && 'hola_input--sm')
    }), tags.exp.error[GET] && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid date")), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_cvv' : 'cc_w_90')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls, 'lbl--tooltip')
    }, "CVV ", /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cvv,
      cls: "ccard_tooltip_icon",
      cls_cn: "cards_tooltip cards_tooltip_to_left"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(tooltip_icon),
      className: cn('question', 'lazyload'),
      alt: "toolip_icon"
    }))), /*#__PURE__*/React.createElement("div", {
      "data-bluesnap": "cvv",
      ref: refs.cvv,
      className: cn('hola_input hola_input--bluesnap_hpf', get_hpf_cls('cvv'), props.input_small && 'hola_input--sm')
    }), tags.cvv.error[GET] && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid CVV")), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', props.email_in_cc && !props.user ? is_hola2023 ? 'field_name no_user' : 'cc_w_268' : is_hola2023 ? 'field_name is_user' : 'cc_w_100w')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Name on card"), /*#__PURE__*/React.createElement("form", {
      onSubmit: submit
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: cn('hola_input', st.name_err && 'hola_input--error', props.input_small && 'hola_input--sm'),
      name: "name",
      value: st.name,
      placeholder: "Full name",
      autoComplete: "cc-name",
      onChange: on_change_name,
      onBlur: ev => validate_name(ev.target.value, true)
    })), st.name_err && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid name")), props.email_in_cc && !props.user && /*#__PURE__*/React.createElement(Input, {
      cl: cn('email_field', is_hola2023 ? 'field_email' : 'cc_w_268'),
      size: props.input_small ? 'sm' : undefined,
      onKeyDown: props.on_email_key_down,
      on_change_validation: false,
      name: "email",
      auto_complete: "email",
      value: props.email,
      validator: plus_util.email_validator,
      inputmode: "email",
      placeholder: "name@example.com",
      label: "Email",
      on_validation: props.set_email_err,
      error: props.email_error,
      on_change: props.set_email
    })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "Card number", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cn,
      cls_cn: "cards_tooltip"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('info.svg'),
      className: cn('question', 'lazyload'),
      alt: "info"
    })), /*#__PURE__*/React.createElement("div", {
      className: cn('ccn', st.card_brand && 'with_card_brand')
    }, st.card_brand && /*#__PURE__*/React.createElement("div", {
      className: "card_brand_icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: get_bluesnap_card_brand_icon(st.card_brand),
      alt: "bluesnap",
      className: "lazyload"
    })), /*#__PURE__*/React.createElement("div", {
      ref: refs.ccn,
      "data-bluesnap": "ccn",
      className: cn('hola_input hola_input--bluesnap_hpf', get_hpf_cls('ccn'), props.input_small && 'hola_input--sm')
    })), tags.ccn.error[GET] && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid card number"))))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-exp"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "Expiry date", /*#__PURE__*/React.createElement("div", {
      "data-bluesnap": "exp",
      ref: refs.exp,
      className: cn('hola_input hola_input--bluesnap_hpf', get_hpf_cls('exp'), props.input_small && 'hola_input--sm')
    }), tags.exp.error[GET] && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid expiry date")))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-2 col-cvv"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "CVV ", /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cvv,
      cls_cn: "cards_tooltip"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('info.svg'),
      className: cn('question', 'lazyload'),
      alt: "info"
    })), /*#__PURE__*/React.createElement("div", {
      "data-bluesnap": "cvv",
      ref: refs.cvv,
      className: cn('hola_input hola_input--bluesnap_hpf', get_hpf_cls('cvv'), props.input_small && 'hola_input--sm')
    }), tags.cvv.error[GET] && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid CVV")))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-6 col-name"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "Name on card"), /*#__PURE__*/React.createElement("form", {
      onSubmit: submit
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: cn('hola_input', st.name_err && 'hola_input--error', props.input_small && 'hola_input--sm'),
      name: "name",
      value: st.name,
      placeholder: " ",
      autoComplete: "cc-name",
      onChange: on_change_name,
      onBlur: ev => validate_name(ev.target.value, true)
    })), st.name_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid name"))))), st.err_msg && /*#__PURE__*/React.createElement("div", {
      className: "row pay-err"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert alert-danger"
    }, st.err_msg)))), !props.with_skeleton || st.inited ? /*#__PURE__*/React.createElement(Fragment, null, !props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "cc_bluesnap_promo"
    })), props.before_btn_component, is_hola2023 ? props.bundle == 'toolip' && props.purchase_disabled ? props.purchase_disabled_warning : /*#__PURE__*/React.createElement(With_legal, props, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({
      disabled: submitting,
      arrow: true,
      caption: props.submit_caption,
      cls: "submit_btn",
      on_click: submit,
      tab_index: "38"
    }, props.btn_props || {})), props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "cc_bluesnap_promo"
    })))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      onClick: submit,
      disabled: submitting,
      tabIndex: "38"
    }, submitting && /*#__PURE__*/React.createElement(Spinner, null), !submitting && /*#__PURE__*/React.createElement("span", null, "Place your order")), !props.no_legal && /*#__PURE__*/React.createElement(Legal, props))) : /*#__PURE__*/React.createElement(Fragment, null), plus_util.test.fallback_promo && /*#__PURE__*/React.createElement(Fallback_promo, _extends({}, props, {
      show: st.show_fp,
      on_close: on_close_fp,
      on_submit: submit,
      submitting: submitting,
      fallback_plan: st.fallback_plan
    }))));
  };
  E.CC_bluesnap_hpf = CC_bluesnap_hpf;
  var noop = () => {
    console.log('noop');
  };
  var CC_stripe_fake = props => {
    var _useContext7 = useContext(Settings_context),
      theme = _useContext7.theme,
      theme_name = _useContext7.theme_name;
    var is_hola2023 = theme_name != 'default';
    var is_bb = theme_name === 'browserai';
    var email = props.email,
      email_error = props.email_error;
    var input_label_cls = !is_hola2023 && cn(theme.xs, theme.logo_grey);
    var cc_cls = cn(props.email_in_cc ? 'ccard_with_email' : 'ccard_form', 'initializing', is_hola2023 && 'hola2023');
    var tooltip_icon = is_hola2023 ? '/hola2023/icons/16/question.svg' : 'info.svg';
    return /*#__PURE__*/React.createElement("div", {
      className: cn('step-payment-item', 'other')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement(Card_skeleton, {
      abs: true
    }), /*#__PURE__*/React.createElement("div", {
      className: cc_cls
    }, /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_number' : 'cc_w_340')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls, 'lbl--tooltip')
    }, "Card number", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cn,
      cls_cn: "cards_tooltip",
      cls: "ccard_tooltip_icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(tooltip_icon),
      className: cn('question', 'lazyload'),
      alt: "toolip_icon"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "fake_stripe_card_number",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    })), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_exp' : 'cc_w_90')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Expiry date"), /*#__PURE__*/React.createElement("div", {
      id: "fake_stripe_card_expiry",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    })), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_cvv' : 'cc_w_90')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls, 'lbl--tooltip')
    }, "CVV ", /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cvv,
      cls: "ccard_tooltip_icon",
      cls_cn: "cards_tooltip cards_tooltip_to_left"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(tooltip_icon),
      className: cn('question', 'lazyload'),
      alt: "toolip_icon"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "fake_stripe_card_cvv",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    })), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', props.email_in_cc && !props.user ? is_hola2023 ? 'field_name no_user' : 'cc_w_268' : is_hola2023 ? 'field_name is_user' : 'cc_w_100w')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Name on card"), /*#__PURE__*/React.createElement("form", {
      onSubmit: noop
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: cn('hola_input', props.input_small && 'hola_input--sm'),
      name: "name",
      value: '',
      placeholder: "Full name",
      autoComplete: "cc-name",
      onChange: noop
    }))), props.email_in_cc && !props.user && /*#__PURE__*/React.createElement(Input, {
      cl: cn('email_field', is_hola2023 ? 'field_email' : 'cc_w_268'),
      size: props.input_small ? 'sm' : undefined,
      onKeyDown: props.on_email_key_down,
      on_change_validation: false,
      name: "email",
      auto_complete: "email",
      value: email,
      validator: plus_util.email_validator,
      inputmode: "email",
      placeholder: is_bb ? 'Enter your email' : 'name@example.com',
      label: "Email",
      on_validation: props.set_email_err,
      error: email_error,
      on_change: props.set_email
    }))));
  };
  var stripe_submitting, stripe_inited;
  var CC_stripe = props => {
    var _props$plan2;
    var _useContext8 = useContext(Settings_context),
      theme = _useContext8.theme,
      theme_name = _useContext8.theme_name;
    var is_hola2023 = theme_name != 'default';
    var is_bb = theme_name === 'browserai';
    var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      inited = _useState24[0],
      set_inited = _useState24[1];
    var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      loading = _useState26[0],
      set_loading = _useState26[1];
    var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      card_number_err = _useState28[0],
      set_card_number_err = _useState28[1];
    var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      card_expiry_err = _useState30[0],
      set_card_expiry_err = _useState30[1];
    var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      card_cvv_err = _useState32[0],
      set_card_cvv_err = _useState32[1];
    var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      name_err = _useState34[0],
      set_name_err = _useState34[1];
    var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      show_fp = _useState36[0],
      set_show_fp = _useState36[1];
    var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      fp_shown = _useState38[0],
      set_fp_shown = _useState38[1];
    var _useState39 = useState(false),
      _useState40 = _slicedToArray(_useState39, 2),
      fallback_plan = _useState40[0],
      set_fallback_plan = _useState40[1];
    var _useState41 = useState(''),
      _useState42 = _slicedToArray(_useState41, 2),
      name = _useState42[0],
      set_name = _useState42[1];
    var _useState43 = useState(''),
      _useState44 = _slicedToArray(_useState43, 2),
      err_msg = _useState44[0],
      set_err_msg = _useState44[1];
    var email = props.email,
      email_error = props.email_error;
    var card_number_ref = useRef();
    var immutable_root = useRef({});
    var stripe_ref = useRef();
    var submitting = props.submitting && props.last_submit_is('stripe', 'api') || loading;
    var after_payment = props.after_payment || (() => test_log('stripe after payment'));
    stripe_submitting = submitting;
    stripe_inited = inited;
    var btn_cls = cn('hola_btn hola_btn--round hola_btn--w100', submitting && 'submitting', props.hidden_checkout && 'hidden_checkout');
    var get_perr_info = () => {
      var plan = props.plan;
      var currency = plan && zmembership.get_plan_currency(plan, props.currency) || props.currency;
      var price_plan = plan && zmembership.get_price_plan(plan, currency);
      return zutil.omit_empty({
        email: props.get_email(),
        name,
        gateway: 'stripe',
        hola_uid: props.get_hola_uid(),
        hola_plan_id: plan === null || plan === void 0 ? void 0 : plan.id,
        period: plan === null || plan === void 0 ? void 0 : plan.period,
        plan_id: plan && plus_util.get_stripe_plan_id(plan, currency),
        price: price_plan === null || price_plan === void 0 ? void 0 : price_plan.price,
        currency,
        bundle: props.bundle,
        cart: props.cart,
        sbx: props.api.test_env
      });
    };
    var _perr = (id, info) => perr({
      id,
      info: assign(get_perr_info(), info)
    });
    var show_fallback_promo = fp => {
      test_log('fallback_plan', fp);
      var plan = props.plan,
        plans = props.plans;
      var fps = [fp];
      plans_util.activate_discount_plans(fps, plans);
      var ids = plans_util.merge_plans(plans, fps);
      props.set_plans(_.values(plans_util.get_plans_info(ids)));
      props.set_plan(plan);
      set_show_fp(true);
      set_fp_shown(true);
      set_fallback_plan(fp);
      _perr('www_premium_fallback_promo');
      return true;
    };
    var on_close_fp = () => {
      set_show_fp(false);
      set_fp_shown(true);
      set_fallback_plan(false);
    };
    var test_show_fp = () => {
      var plan = props.plan || {};
      if (!fp_shown) {
        var fp = plans_util.get_plan_info(plan.fallback_plan);
        fp && show_fallback_promo(fp);
      }
    };
    var set_err = err => {
      var _err$hola_info;
      var _ref2 = err || {},
        code = _ref2.code,
        decline_code = _ref2.decline_code;
      zerr('stripe error %O', err);
      if (err.error == 'invalid_email') return;
      var plan = props.plan || {};
      var fp;
      if (plus_util.test.fallback_promo && !fp_shown && (qs_o().debug_fallback_promo || decline_code == 'insufficient_funds') && (fp = plan.fallback_plan)) {
        fp = plans_util.get_plan_info(fp);
        if (fp && show_fallback_promo(fp)) return;
      }
      if (fp_shown) on_close_fp();
      if (qs_o().debug_suspect_dlg) susp_dlg('stripe_susp', is_hola2023);
      if (!props.avangate_fallback_if || !props.avangate_fallback_if(!(code && (code.startsWith('expired_') || code.startsWith('incorrect_')) || {
        fraudulent: 1,
        do_not_honor: 1,
        live_mode_test_card: 1
      }[decline_code] || ((_err$hola_info = err.hola_info) === null || _err$hola_info === void 0 ? void 0 : _err$hola_info.status) == 403))) {
        props.on_err_dlg ? props.on_err_dlg() : err_dlg('stripe', is_hola2023, theme_name);
      }
      var msg = err.pub_reason || plus_util.generic_err;
      // set_err_msg(msg);
      _perr('www_premium_payment_submit_failed_stripe', assign({
        msg,
        err: err && err.stack || zerr.e2s(err)
      }, _.omit(err, ['subscr'])));
    };
    var submit = (event, opt) => {
      if (event && event.preventDefault) event.preventDefault();
      if (props.purchase_disabled) return;
      if (stripe_submitting || !stripe_inited) return;
      if (props.before_payment) props.before_payment();
      var api = stripe_ref.current;
      _perr('www_premium_payment_submit_clicked_stripe', assign({
        payment_type: 'api',
        name
      }));
      send_submit_event();
      var invalid;
      if (!props.user && (!email || email_error)) {
        props.set_email_err(email_error || empty_email_err);
        invalid = true;
      }
      if (!validate_name()) invalid = true;
      set_loading(true);
      set_err_msg('');
      var card_last4, card_type, card_country, payment_method_id;
      api.createPaymentMethod({
        type: 'card',
        card: card_number_ref.current,
        billing_details: {
          name
        }
      }).then(result => etask(function* () {
        test_log('stripe result', result);
        payment_method_id = zutil.get(result, 'paymentMethod.id');
        card_last4 = zutil.get(result, 'paymentMethod.card.last4');
        card_type = zutil.get(result, 'paymentMethod.card.brand');
        card_country = zutil.get(result, 'paymentMethod.card.country');
        if (invalid) {
          if (props.on_submit_err) props.on_submit_err();
          return set_loading(false);
        }
        if (result.error) {
          zerr('stripe error %O', result.error);
          if (result.error.type != 'validation_error') {
            set_err(assign({
              pub_reason: result.error.message,
              card_last4,
              card_type,
              payment_method_id
            }, result.error));
          }
          if (props.on_submit_err) props.on_submit_err();
          return set_loading(false);
        }
        opt = assign({}, opt, {
          payment_method_id,
          name,
          stripe: api,
          quantity: props.quantity,
          email,
          plan: props.plan,
          cart: props.cart,
          bundle: props.bundle
        });
        // always charge US cards in USD
        if (card_country == 'US') opt.currency = 'USD';
        opt._currency = props.currency;
        var res = (yield props.submit_payment('stripe', opt)) || {
          error: 'empty submit result'
        };
        if (res.error && !res.paid) {
          set_loading(false);
          after_payment();
          return set_err(assign(res, {
            card_last4,
            card_type,
            payment_method_id
          }));
        }
        test_log('stripe payment completed');
        if (props.on_payment) return props.on_payment(assign({
          gateway: 'stripe'
        }, res));
        location.href = plus_util.after_payment_page({
          gateway: 'stripe',
          email: res.email || email
        });
      })).catch(e => {
        test_log_error('stripe payment err', e);
        set_loading(false);
        _perr('www_premium_payment_stripe_err', {
          err: e && e.stack || zerr.e2s(e)
        });
        set_err(assign(e, {
          card_last4,
          card_type,
          payment_method_id
        }));
        after_payment();
      });
    };
    immutable_root.current.submit = submit;
    useEffect(() => {
      var init_err, last_init_err, mount_timer;
      var on_submit_requested = event => {
        if (event.state.provider == 'stripe') immutable_root.current.submit();
      };
      var on_email_passed_focus = event => {
        if (event.state.provider == 'stripe' && card_number_ref.current) card_number_ref.current.focus();
      };
      var mount = () => {
        var api = window.Stripe(zutil.get(hopt, 'stripe.' + (props.api.test_env ? 'test' : 'live')));
        stripe_ref.current = api;
        var api_options = is_bb ? {
          fonts: [{
            family: 'Roboto Mono',
            src: `url(${url2md5('/www/hola/pub/font/Roboto-Mono.ttf')})`,
            weight: '400'
          }]
        } : is_hola2023 ? {
          fonts: [{
            family: 'Poppins',
            src: `url(${url2md5('/www/hola/pub/font/poppins_400.woff2')})`,
            weight: '400'
          }]
        } : undefined;
        var elements = api.elements(api_options);
        var style = www_util.deep_merge({
          base: {
            border: 'blue solid 1px',
            fontFamily: is_bb ? 'Roboto Mono' : is_hola2023 ? 'Poppins, sans-serif' : 'Montserrat, sans-serif',
            fontWeight: is_hola2023 ? '400' : '500',
            fontSize: '14px',
            '::placeholder': {
              color: is_bb ? '#A3A3A3' : is_hola2023 ? '#7D7D7D' : '#A3B5CA'
            }
          },
          invalid: is_hola2023 ? {
            color: is_bb ? '#A3A3A3' : '#e37278',
            '::placeholder': {
              color: '#e37278'
            }
          } : undefined
        }, props.input_style || {});
        var classes = {
          focus: 'hola_input--focus',
          invalid: 'hola_input--error',
          empty: 'hola_input--placeholder'
        };
        var c_number = elements.create('cardNumber', {
          style,
          classes,
          placeholder: '0000 0000 0000 0000',
          showIcon: !is_hola2023
        });
        c_number.on('change', ev => set_card_number_err(!!ev.error));
        c_number.on('ready', () => {
          c_number.focus();
          set_inited(true);
          props.on_load && props.on_load();
        });
        c_number.mount('#stripe_card_number');
        card_number_ref.current = c_number;
        var c_expiry = elements.create('cardExpiry', {
          style,
          classes,
          placeholder: is_bb ? 'MM/YY' : 'mm/yy'
        });
        c_expiry.on('change', ev => set_card_expiry_err(!!ev.error));
        c_expiry.mount('#stripe_card_expiry');
        var c_cvv = elements.create('cardCvc', {
          style,
          classes,
          placeholder: '000'
        });
        c_cvv.on('change', ev => set_card_cvv_err(!!ev.error));
        c_cvv.mount('#stripe_card_cvv');
        test_log('mounted stripe');
        _perr('www_premium_payment_stripe_inited');
        E.emitter.on('email_passed_focus', on_email_passed_focus);
        E.emitter.on('submit_requested', on_submit_requested);
        clearTimeout(init_timer);
      };
      mount_timer = setInterval(() => {
        try {
          mount();
          clearInterval(mount_timer);
          init_err = null;
        } catch (e) {
          init_err = zerr.e2s(e);
          if (init_err != last_init_err) test_log_error('stripe init err', init_err);
          last_init_err = init_err;
        }
      }, _.get(hopt, 'www_hola.payment.stripe.init_interval', 0.1) * SEC);
      var timeout = _.get(hopt, 'www_hola.payment.stripe.init_timeout', 5);
      var try_n = 1;
      var init_timer = setInterval(() => {
        test_log('stripe initer timer', try_n);
        // try one more time if no choice
        // TODO vitaly: hide cc payment in this case
        if (!zutil.get(props, 'plan.bluesnap') && try_n < 2) return try_n++;
        clearInterval(init_timer);
        clearInterval(mount_timer);
        test_log_error('init_err', init_err);
        test_log('stop attempt to mount stripe');
        _perr('www_premium_payment_stripe_init_timeout', {
          init_err,
          timeout
        });
        if (props.set_fallback_route) {
          props.set_fallback_route([['cc', 'stripe', 'api'], ['cc', 'bluesnap', plus_util.api.bs_def], ['cc', 'avangate', '2pay']]);
        }
        plus_util.no_test.cc_payment = plus_util.conf.no_stripe = true;
      }, timeout * SEC);
      return () => {
        clearInterval(init_timer);
        clearInterval(mount_timer);
        E.emitter.removeListener('email_passed_focus', on_email_passed_focus);
        E.emitter.removeListener('submit_requested', on_submit_requested);
      };
    }, []);
    var on_change_name = ev => {
      set_name(ev.target.value);
      set_name_err(false);
    };
    var validate_name = (v, allow_empty) => {
      v = v || name;
      v = ('' + (v || '')).trim();
      if (!v && allow_empty) return;
      set_name_err(!v);
      set_name(v);
      return !!v;
    };
    useEffect(() => {
      var _props$plan;
      if (!inited || !((_props$plan = props.plan) !== null && _props$plan !== void 0 && _props$plan.fallback_plan)) return;
      if (qs_o().debug_fallback_promo) test_show_fp();
    }, [inited, (_props$plan2 = props.plan) === null || _props$plan2 === void 0 ? void 0 : _props$plan2.fallback_plan]);
    var input_label_cls = !is_hola2023 && cn(theme.xs, theme.logo_grey);
    var cc_cls = cn(props.email_in_cc ? 'ccard_with_email' : 'ccard_form', !inited && 'initializing', is_hola2023 && 'hola2023', props.bundle == 'toolip' && 'is_toolip');
    var tooltip_icon = is_bb ? '/hola2023/icons/16/question_neutrals.svg' : is_hola2023 ? '/hola2023/icons/16/question.svg' : 'info.svg';
    var tooltip_icon_err = '/hola2023/icons/16/warning_error.svg';
    var Button_cmp = props.Button_cmp || Button;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('step-payment-item', 'other', !props.show && 'hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, props.with_skeleton && !inited && /*#__PURE__*/React.createElement(Card_skeleton, {
      abs: true
    }), /*#__PURE__*/React.createElement("div", {
      className: cc_cls
    }, submitting && /*#__PURE__*/React.createElement("div", {
      className: "form-overlay"
    }), props.email_in_cc || is_hola2023 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_number' : 'cc_w_340')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls, 'lbl--tooltip')
    }, "Card number", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      content: props.Tooltip_card || tooltip_cn,
      cls_cn: props.Tooltip_card ? '' : 'cards_tooltip',
      cls: "ccard_tooltip_icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(card_number_err ? tooltip_icon_err : tooltip_icon),
      className: cn('question', 'lazyload', card_number_err && 'error'),
      alt: "toolip_icon"
    })), props.cc_label_with_card_icons && /*#__PURE__*/React.createElement("span", {
      className: "cc_icons"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(is_bb ? 'visa_bb.svg' : 'visa.svg'),
      alt: "visa",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(is_bb ? 'mastercard_bb.svg' : 'mastercard_2023.svg'),
      alt: "mastercard",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(is_bb ? 'amex_bb.svg' : 'amex_2023.svg'),
      alt: "amex",
      className: "lazyload"
    }), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(is_bb ? 'discover_bb.svg' : 'discover.svg'),
      alt: "discover",
      className: "lazyload"
    })), props.secured_elems_test && /*#__PURE__*/React.createElement("span", {
      className: cn('secured_text', card_number_err && 'secured_text--err')
    }, "Secured and encrypted")), /*#__PURE__*/React.createElement("div", {
      id: "stripe_card_number",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    }), card_number_err && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid card number")), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_exp' : 'cc_w_90')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Expiry date", card_expiry_err && /*#__PURE__*/React.createElement("span", {
      className: cn('ccard_tooltip_icon')
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(tooltip_icon_err),
      className: cn('question', 'lazyload', card_expiry_err && 'error'),
      alt: "toolip_icon"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "stripe_card_expiry",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    }), card_expiry_err && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid date")), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', is_hola2023 ? 'field_cvv' : 'cc_w_90')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls, 'lbl--tooltip')
    }, "CVV ", /*#__PURE__*/React.createElement(Tooltip, {
      content: props.Tooltip_cvv || tooltip_cvv,
      cls: "ccard_tooltip_icon",
      cls_cn: cn(props.Tooltip_cvv ? '' : 'cards_tooltip', 'cards_tooltip_to_left')
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(card_cvv_err ? tooltip_icon_err : tooltip_icon),
      className: cn('question', 'lazyload', card_cvv_err && 'error'),
      alt: "toolip_icon"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "stripe_card_cvv",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    }), card_cvv_err && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid CVV")), /*#__PURE__*/React.createElement("label", {
      className: cn('form_field', props.email_in_cc && !props.user ? is_hola2023 ? 'field_name no_user' : 'cc_w_268' : is_hola2023 ? 'field_name is_user' : 'cc_w_100w')
    }, /*#__PURE__*/React.createElement("span", {
      className: cn('lbl', input_label_cls)
    }, "Name on card", name_err && /*#__PURE__*/React.createElement("span", {
      className: cn('ccard_tooltip_icon')
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(tooltip_icon_err),
      className: cn('question', 'lazyload', name_err && 'error'),
      alt: "toolip_icon"
    }))), /*#__PURE__*/React.createElement("form", {
      onSubmit: submit
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: cn('hola_input', name_err && 'hola_input--error', props.input_small && 'hola_input--sm'),
      name: "name",
      value: name,
      placeholder: "Full name",
      autoComplete: "cc-name",
      onChange: on_change_name,
      onBlur: ev => validate_name(ev.target.value, true)
    })), name_err && /*#__PURE__*/React.createElement("span", {
      className: cn('err_msg', is_hola2023 && 'err_msg--hola2023')
    }, "Invalid name")), props.email_in_cc && !props.user && /*#__PURE__*/React.createElement(Input, {
      cl: cn('email_field', is_hola2023 ? 'field_email' : 'cc_w_268'),
      size: props.input_small ? 'sm' : undefined,
      onKeyDown: props.on_email_key_down,
      name: "email",
      auto_complete: "email",
      value: email,
      validator: plus_util.email_validator,
      inputmode: "email",
      icon: email_error ? /*#__PURE__*/React.createElement("img", {
        src: plus_util.img_url(tooltip_icon_err),
        className: cn('question', 'lazyload', email_error && 'error'),
        alt: "toolip_icon"
      }) : '',
      placeholder: is_bb ? 'Enter your email' : 'name@example.com',
      label: "Email",
      on_validation: props.set_email_err,
      error: email_error,
      on_change: props.set_email
    })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "Card number", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cn,
      cls_cn: "cards_tooltip"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('info.svg'),
      className: cn('question', 'lazyload'),
      alt: "info"
    })), /*#__PURE__*/React.createElement("div", {
      id: "stripe_card_number",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    }), card_number_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid card number"))))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-exp"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "Expiry date", /*#__PURE__*/React.createElement("div", {
      id: "stripe_card_expiry",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    }), card_expiry_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid expiry date")))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-2 col-cvv"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "CVV ", /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip_cvv,
      cls_cn: "cards_tooltip"
    }, /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('info.svg'),
      className: cn('question', 'lazyload'),
      alt: "info"
    })), /*#__PURE__*/React.createElement("div", {
      id: "stripe_card_cvv",
      className: cn('hola_input hola_input--stripe', props.input_small && 'hola_input--sm')
    }), card_cvv_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid CVV")))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-6 col-name"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, "Name on card"), /*#__PURE__*/React.createElement("form", {
      onSubmit: submit
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: cn('hola_input', name_err && 'hola_input--error', props.input_small && 'hola_input--sm'),
      name: "name",
      value: name,
      placeholder: " ",
      autoComplete: "cc-name",
      onChange: on_change_name,
      onBlur: ev => validate_name(ev.target.value, true)
    })), name_err && /*#__PURE__*/React.createElement("span", {
      className: "err_msg"
    }, "Invalid name"))))), err_msg && /*#__PURE__*/React.createElement("div", {
      className: "row pay-err"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert alert-danger"
    }, err_msg)))), inited && /*#__PURE__*/React.createElement(Fragment, null, !props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "cc_stripe_promo"
    })), props.bundle == 'browserai' ? null : props.before_btn_component, is_hola2023 ? props.bundle == 'toolip' && props.purchase_disabled ? props.purchase_disabled_warning : /*#__PURE__*/React.createElement(With_legal, props, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button_cmp, _extends({
      disabled: submitting,
      arrow: true,
      caption: props.submit_caption,
      cls: "submit_btn",
      on_click: submit,
      tab_index: "38"
    }, props.btn_props || {})), props.secured_elems_test && /*#__PURE__*/React.createElement("p", {
      className: cn(theme.p4, theme.med, 'secured_elems_test--legal')
    }, "Cancel online any time.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('/hola2023/icons/16/wavy_check.svg'),
      alt: "wavy_check",
      className: "lazyload"
    }), "You're 100% backed by our money-back guarantee ", /*#__PURE__*/React.createElement("a", {
      href: "/faq#refund-policy",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "policy"), "."), props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "cc_stripe_promo"
    })))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      onClick: submit,
      disabled: submitting,
      tabIndex: "38"
    }, submitting && /*#__PURE__*/React.createElement(Spinner, null), !submitting && /*#__PURE__*/React.createElement("span", null, "Place your order")), !props.no_legal && /*#__PURE__*/React.createElement(Legal, props))), plus_util.test.fallback_promo && /*#__PURE__*/React.createElement(Fallback_promo, _extends({}, props, {
      show: show_fp,
      on_close: on_close_fp,
      on_submit: submit,
      submitting: submitting,
      fallback_plan: fallback_plan
    }))));
  };
  E.CC_stripe = CC_stripe;
  E.CC_adyen = CC_adyen;
  var checkout_started = false;
  E.start_checkout = () => {
    if (checkout_started) return;
    checkout_started = true;
  };
  var focus_first_card = () => {
    setTimeout(() => {
      var cnum = document.querySelector('[name="ccard_number"]');
      if (cnum) cnum.focus();
    }, 100);
  };
  E.before_payment = (opt = {}) => {
    var force_test_env = Boolean(zurl.qs_parse(location.search.substring(1)).test);
    return etask(function* () {
      var user = opt.user || (yield plus_util.login_get_user());
      var email = opt.email;
      if (!email && user) email = _.get(user, 'emails[0].value');
      var is_new_user;
      if (!user) {
        is_new_user = true;
        user = email ? {
          hola_uid: 'basic/' + email,
          emails: [{
            value: email
          }],
          provider: 'basic'
        } : {};
      }
      var plan = opt.plan;
      return {
        is_new_user,
        user,
        period: plan.period,
        plan_id: plan.id,
        plan,
        email,
        coupon: opt.coupon,
        currencies: opt.currencies,
        price: zmembership.get_price_plan(plan, opt.currency).price,
        currency: zmembership.get_plan_currency(plan, opt.currency),
        vat_obj: opt.vat_obj,
        sbx: force_test_env
      };
    });
  };
  var Fallback_promo = props => {
    var _useContext9 = useContext(Settings_context),
      theme = _useContext9.theme,
      theme_name = _useContext9.theme_name;
    var is_hola2023 = theme_name != 'default';
    var submitting = props.submitting,
      currency = props.currency;
    var plan = props.fallback_plan;
    var base_plan_info = plan ? plans_util.get_plan_info(plan.base_plan) : null;
    var old_price = base_plan_info ? zmembership.get_price_plan(base_plan_info, currency).price : -1;
    var new_price = zmembership.get_price_plan(plan, currency).price;
    var off = +(100 * (old_price - new_price) / old_price).toFixed();
    var was_yearly = base_plan_info ? base_plan_info.every == '3 years' || base_plan_info.every == 'year' : false;
    var goes_to_month = plan.every == 'month';
    var text = 'You\'re getting an extra discount! on us!';
    var with_title = true;
    var with_discount_icon = true;
    if (base_plan_info && base_plan_info.every == '3 years' && goes_to_month) {
      with_title = false;
      with_discount_icon = false;
      text = /*#__PURE__*/React.createElement(Fragment, null, "How about we switch you", /*#__PURE__*/React.createElement("br", null), "to a monthly rate?");
    }
    if (base_plan_info && base_plan_info.every == 'year' && goes_to_month) {
      with_discount_icon = false;
      text = 'How about we switch you to a discounted monthly rate?';
    }
    var cta = was_yearly && goes_to_month ? 'Switch plans and buy' : 'Claim discount';
    useEffect(() => {
      if (props.show && base_plan_info) {
        var suff = base_plan_info.every.replace(/ /g, '');
        perr({
          id: `www_fallback_plan_show_${suff}`
        });
      }
    }, [props.show]);
    var on_click = ev => {
      ev.preventDefault();
      var suff = base_plan_info.every.replace(/ /g, '');
      perr({
        id: `www_fallback_promo_click_buy_${suff}`
      });
      props.on_submit(ev, {
        plan
      });
    };
    if (!plan) return null;
    return /*#__PURE__*/React.createElement(Modal, {
      is_open: props.show,
      width: is_hola2023 ? 335 : 462,
      on_close: props.on_close,
      cls: !is_hola2023 && 'fallback_promo',
      portal: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "fallback_promo_hola2023"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/cms/wp-content/uploads/2023/09/gift.png",
      alt: "gift"
    }), with_title && /*#__PURE__*/React.createElement("p", {
      className: cn(theme.p2, theme.bold, 'fallback_promo-title', 'lazyload')
    }, "Congrats!"), /*#__PURE__*/React.createElement("p", {
      className: cn(theme.p3, 'fallback_promo-description')
    }, text), /*#__PURE__*/React.createElement("div", {
      className: "fallback_promo-info-card"
    }, /*#__PURE__*/React.createElement("p", {
      className: cn(theme.p3, theme.bold, 'fallback_promo-info-title')
    }, "Hola Premium"), /*#__PURE__*/React.createElement("div", {
      className: "fallback_promo-info-price-container"
    }, /*#__PURE__*/React.createElement("h5", null, zcountry.format_price(currency, new_price)), /*#__PURE__*/React.createElement("p", {
      className: theme.p3
    }, "/", zmembership.get_per(plan.period))), with_discount_icon ? /*#__PURE__*/React.createElement("p", {
      className: theme.p4
    }, /*#__PURE__*/React.createElement("span", {
      className: "fallback_promo-old-price"
    }, zcountry.format_price(currency, old_price)), ' ', zcountry.format_price(currency, new_price), " billed every ", zmembership.get_per(plan.period)) : /*#__PURE__*/React.createElement("p", {
      className: theme.p4
    }, "instead of the ", (base_plan_info.every || '').replace('years', 'year'), " plan billed at ", zcountry.format_price(currency, old_price)), with_discount_icon && /*#__PURE__*/React.createElement("div", {
      className: "fallback_promo-info-off-percentage-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "fallback_promo-info-off-percentage"
    }, off, "% OFF"))), /*#__PURE__*/React.createElement(Button, {
      caption: cta,
      on_click: on_click,
      arrow: !was_yearly || !goes_to_month,
      cls: "fallback_promo-button",
      disabled: submitting
    })));
  };
  var Checkout_promo = props => {
    var id = props.id,
      coupon = props.coupon,
      plan = props.plan,
      plans = props.plans,
      set_coupon = props.set_coupon,
      input_small = props.input_small,
      applied_coupon = props.applied_coupon,
      apply_coupon = props.apply_coupon,
      summary_test = props.summary_test;
    var _useContext0 = useContext(Settings_context),
      theme = _useContext0.theme,
      theme_name = _useContext0.theme_name;
    var is_hola2023 = theme_name != 'default';
    var toggle_open = () => {
      set_opened(v => !v);
      if (props.on_change_view) props.on_change_view();
    };
    var _useState45 = useState(coupon),
      _useState46 = _slicedToArray(_useState45, 2),
      code = _useState46[0],
      set_code = _useState46[1];
    var _useState47 = useState(false),
      _useState48 = _slicedToArray(_useState47, 2),
      sending = _useState48[0],
      set_sending = _useState48[1];
    var is_active_plan_discount = plans_util.is_plan_discount(plan);
    var _useState49 = useState(coupon && !is_active_plan_discount),
      _useState50 = _slicedToArray(_useState49, 2),
      opened = _useState50[0],
      set_opened = _useState50[1];
    var _useState51 = useState(!code || !is_active_plan_discount),
      _useState52 = _slicedToArray(_useState51, 2),
      is_quest = _useState52[0],
      set_quest = _useState52[1];
    var _useState53 = useState(code && !is_active_plan_discount ? plans_util.get_valid_message() : ''),
      _useState54 = _slicedToArray(_useState53, 2),
      status = _useState54[0],
      set_status = _useState54[1];
    var success = code && applied_coupon && code == applied_coupon && is_active_plan_discount;
    var on_change = ev => {
      if (status) set_status('');
      set_code(ev.target.value);
    };
    useEffect(() => {
      set_status(code && applied_coupon && code == applied_coupon && !is_active_plan_discount ? plans_util.get_valid_message() : '');
      set_quest(!code || !is_active_plan_discount);
      if (is_hola2023) set_opened(code && !is_active_plan_discount || success);else set_opened(code && !is_active_plan_discount);
    }, [is_active_plan_discount]);
    var on_apply = () => etask(function* () {
      set_status(`Loading...`);
      this.finally(() => {
        set_sending(false);
      });
      set_sending(true);
      var res = yield $.get('/users/payment/apply_coupon', {
        code
      });
      if (!res || res.error) {
        plans_util.activate_discount_plans([]);
        set_quest(true);
        set_status(plans_util.get_valid_message());
        set_coupon('');
      } else {
        var pl = plan;
        if (res.plans) {
          plans_util.activate_discount_plans(res.plans, plans);
          pl = plans_util.get_discount_plan(plan) || plan;
          var ids = plans_util.merge_plans(plans, res.plans);
          props.set_plans(_.values(plans_util.get_plans_info(ids)));
        }
        var is_active_discount = plans_util.is_plan_discount(pl);
        if (is_active_discount) {
          set_quest(false);
          set_opened(is_hola2023);
          set_status('');
        } else {
          set_quest(true);
          set_status(plans_util.get_valid_message());
        }
        set_coupon(code);
        apply_coupon(code);
        props.set_plan(pl);
      }
    });
    var disabled = !code || sending || !!status;
    var promo_icon = opened ? 'x_close.svg' : 'plus.svg';
    if (props.no_checkout_promo) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('checkout_promo', summary_test && 'in_summary', opened && 'checkout_promo--opened')
    }, /*#__PURE__*/React.createElement("label", {
      className: cn('checkout_promo-toggle', opened && status && 'checkout_promo-row--error'),
      onClick: toggle_open
    }, is_quest || is_hola2023 ? /*#__PURE__*/React.createElement("span", null, "Do you have a ", /*#__PURE__*/React.createElement("span", {
      className: "promo"
    }, "promo code?", /*#__PURE__*/React.createElement("div", {
      className: "underline"
    }), /*#__PURE__*/React.createElement("div", {
      className: "anim"
    }))) : /*#__PURE__*/React.createElement("span", null, "Your promo code was successfuly applied!"), summary_test && /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(`/hola2023/icons/16/${promo_icon}`),
      alt: "promo_icon",
      className: "lazyload"
    })), opened && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "checkout_promo-row"
    }, /*#__PURE__*/React.createElement("input", {
      id: id,
      type: "text",
      value: code,
      disabled: success,
      placeholder: is_hola2023 ? 'Enter code here' : 'Enter promo code',
      className: cn('hola_input', status && 'hola_input--error', input_small && 'hola_input--sm'),
      onChange: on_change
    }), !success && /*#__PURE__*/React.createElement("button", {
      className: cn('hola_btn hola_btn--round', is_hola2023 ? 'hola_btn--white' : 'hola_btn--white', is_hola2023 && 'hola_btn--no_jump', input_small && 'hola_btn--sm'),
      disabled: disabled,
      onClick: on_apply
    }, "Apply")), status && /*#__PURE__*/React.createElement("span", {
      className: cn(theme.P, theme.p5, !is_hola2023 && 'checkout_promo-status', is_hola2023 ? 'err_msg--hola2023' : 'err_msg')
    }, status), success && /*#__PURE__*/React.createElement("span", {
      className: cn(theme.P, theme.p5, !is_hola2023 && 'checkout_promo-success', is_hola2023 ? 'success_msg--hola2023' : 'success_msg')
    }, "Your promo code was successfully applied!")));
  };
  E.Checkout_promo = Checkout_promo;
  var get_vat_res = (vat_obj, price, provider) => {
    if (!vat_obj || !vat_obj.vat_percent || vat_obj.gateway != provider) return;
    var res = {};
    res.vat_percent = (+vat_obj.vat_percent).toFixed(2);
    res.vat = (+vat_obj.vat).toFixed(2);
    res.price = (+vat_obj.price_gross).toFixed(2);
    return assign({}, vat_obj, res);
  };
  var Vat_info = ({
    vat_percent,
    vat,
    currency,
    country,
    state
  }) => {
    country = zcountry.isocode2country(country) + (state ? ', ' + state : '');
    return /*#__PURE__*/React.createElement("span", null, "(includes VAT ", vat_percent, "% ", country, ": ", zcountry.format_price(currency, vat), ")");
  };
  var Checkout_header_experiment = props => {
    var go_back = props.go_back,
      base_price_o = props.base_price_o,
      vat_loading = props.vat_loading,
      vat = props.vat,
      month_price = props.month_price,
      currency = props.currency,
      price = props.price,
      every = props.every;
    return /*#__PURE__*/React.createElement("div", {
      className: "checkout-header"
    }, /*#__PURE__*/React.createElement("a", {
      className: "back-button2",
      onClick: go_back
    }), /*#__PURE__*/React.createElement("p", null, "You chose:"), base_price_o && base_price_o.month_price ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "price"
    }, /*#__PURE__*/React.createElement("b", null, "Pay ", /*#__PURE__*/React.createElement("s", null, zcountry.format_price(currency, base_price_o.price)), ' ', /*#__PURE__*/React.createElement("span", {
      className: "discount_price"
    }, zcountry.format_price(currency, price)), ' ', "once every ", every)), /*#__PURE__*/React.createElement("p", {
      className: "billed"
    }, /*#__PURE__*/React.createElement("span", {
      className: "price-gross"
    }, vat_loading && /*#__PURE__*/React.createElement(Spinner, {
      small: true
    }), " As low as", ' ', /*#__PURE__*/React.createElement("s", null, zcountry.format_price(currency, base_price_o.month_price)), /*#__PURE__*/React.createElement("span", {
      className: "discount_price"
    }, ' ', zcountry.format_price(currency, month_price)), " per month"), vat && /*#__PURE__*/React.createElement(Vat_info, _extends({}, vat, {
      currency: currency
    })))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "price"
    }, /*#__PURE__*/React.createElement("b", null, "Pay ", zcountry.format_price(currency, price), " once every ", every)), /*#__PURE__*/React.createElement("p", {
      className: "billed"
    }, /*#__PURE__*/React.createElement("span", {
      className: "price-gross"
    }, vat_loading && /*#__PURE__*/React.createElement(Spinner, {
      small: true
    }), " As low as ", zcountry.format_price(currency, month_price || price), ' ', "per ", month_price ? 'month' : every), vat && /*#__PURE__*/React.createElement(Vat_info, _extends({}, vat, {
      currency: currency
    })))));
  };
  var Checkout_header = props => {
    var go_back = props.go_back,
      base_price_o = props.base_price_o,
      vat_loading = props.vat_loading,
      vat = props.vat,
      month_price = props.month_price,
      plan_name = props.plan_name,
      currency = props.currency,
      price = props.price,
      plan_id = props.plan_id,
      free_period = props.free_period,
      every = props.every,
      renewal_price = props.renewal_price;
    var plans_to_check = _.get(hopt, 'www_hola.plans_for_full_price') || [];
    if (plans_to_check.includes(plan_id)) return /*#__PURE__*/React.createElement(Checkout_header_experiment, props);
    return /*#__PURE__*/React.createElement("div", {
      className: "checkout-header"
    }, /*#__PURE__*/React.createElement("a", {
      className: "back-button2",
      onClick: go_back
    }), /*#__PURE__*/React.createElement("p", null, "You chose:"), base_price_o && base_price_o.month_price && month_price != base_price_o.month_price ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "price"
    }, /*#__PURE__*/React.createElement("b", null, plan_name, " plan "), /*#__PURE__*/React.createElement("s", null, zcountry.format_price(currency, base_price_o.month_price)), /*#__PURE__*/React.createElement("span", {
      className: "discount_price"
    }, zcountry.format_price(currency, month_price), " / month")), /*#__PURE__*/React.createElement("p", {
      className: "billed"
    }, /*#__PURE__*/React.createElement("span", {
      className: "price-gross"
    }, vat_loading && /*#__PURE__*/React.createElement(Spinner, {
      small: true
    }), " Billed as one payment of ", /*#__PURE__*/React.createElement("s", null, zcountry.format_price(currency, base_price_o.price)), /*#__PURE__*/React.createElement("span", {
      className: "discount_price"
    }, ' ', zcountry.format_price(currency, price))), vat && /*#__PURE__*/React.createElement(Vat_info, _extends({}, vat, {
      currency: currency
    })))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "price"
    }, /*#__PURE__*/React.createElement("b", null, plan_name, " plan"), free_period ? /*#__PURE__*/React.createElement("span", {
      className: "price-free"
    }, "+ ", zmembership.get_per(free_period, true), " Free") : !renewal_price || renewal_price === price ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("b", null, zcountry.format_price(currency, month_price || price)), /*#__PURE__*/React.createElement("span", null, "/ ", month_price ? 'month' : every)) : null), /*#__PURE__*/React.createElement("p", {
      className: "billed"
    }, /*#__PURE__*/React.createElement("span", {
      className: "price-gross"
    }, vat_loading && /*#__PURE__*/React.createElement(Spinner, {
      small: true
    }), " Billed as one payment of ", zcountry.format_price(currency, price)), vat && /*#__PURE__*/React.createElement(Vat_info, _extends({}, vat, {
      currency: currency
    })))));
  };
  E.Checkout_header = Checkout_header;
  var logged_payment_method;
  var Step_payment_internal = (_Class = class Step_payment_internal extends Pure_component {
    constructor(...args) {
      super(...args);
      _defineProperty(this, "state", {
        submitting: false,
        already_plus_err: false,
        fallback_route: {},
        fallback_passed: {},
        applepay_not_supported: true
      });
      _defineProperty(this, "on_choose_method", () => {
        var method = this.method,
          provider = this.provider,
          type = this.type;
        var disable_scroll_to_top = this.props.disable_scroll_to_top;
        send_submit_event();
        if (method == 'other') return void this.submit_payment('bluesnap_apm');
        if (method == 'cc' && provider == 'avangate' && type != '2pay') return void this.submit_avangate();
        this.props.set_method_chosen(true);
        if (!disable_scroll_to_top) window.scrollTo(0, 0);
      });
      _defineProperty(this, "get_hola_uid", user => user && user.hola_uid || this.props.user && this.props.user.hola_uid);
      _defineProperty(this, "submit_avangate", err => {
        var plan = this.props.plan;
        var email = this.get_email();
        this.props.set_api({
          avangate: true,
          is_avangate_fallback: !!err
        });
        var avangate_inline_fallback = plan === null || plan === void 0 ? void 0 : plan.avangate_product;
        this.setState({
          avangate_notice: !!(err && avangate_inline_fallback)
        });
        send_submit_event();
        return this.submit_payment(avangate_inline_fallback ? 'avangate_inline' : 'avangate', {
          email
        });
      });
      _defineProperty(this, "avangate_fallback_if", (cond, err) => {
        var _props$plan3, _props$plan4, _props$plan5;
        var props = this.props;
        var avangate_inline_fallback = (_props$plan3 = props.plan) === null || _props$plan3 === void 0 ? void 0 : _props$plan3.avangate_product;
        var result = cond && avangate_inline_fallback && props.plan.avangate_id;
        perr({
          id: 'www_premium_payment_avangate_fallback_if',
          info: {
            result,
            email: this.get_email(),
            hola_uid: this.get_hola_uid(),
            plan_id: (_props$plan4 = props.plan) === null || _props$plan4 === void 0 ? void 0 : _props$plan4.id,
            avangate_id: (_props$plan5 = props.plan) === null || _props$plan5 === void 0 ? void 0 : _props$plan5.avangate_id,
            err
          }
        });
        if (!result) return;
        this.submit_avangate(err || true);
        return true;
      });
      _defineProperty(this, "go_back", () => {
        this.props.set_method_chosen(false);
        if (!this.props.disable_scroll_to_top) window.scrollTo(0, 0);
      });
      _defineProperty(this, "get_email", (email, user) => {
        email = this.props.user_email || _.get(user || this.props.user, 'emails[0].value') || this.props.email || email;
        if (!email) {
          var el = document.querySelector('.email_field [name="email"]');
          email = el && el.value;
        }
        return (email || '').trim().toLowerCase();
      });
      _defineProperty(this, "set_submitting", submitting => {
        this.setState({
          submitting
        });
        if (this.props.set_submitting) this.props.set_submitting(submitting);
      });
      _defineProperty(this, "before_payment", (provider, type, opt = {}) => {
        this.setState({
          submitting: true,
          last_submit: {
            provider,
            type
          }
        });
        if (this.props.before_payment) {
          this.props.before_payment({
            submitting: true,
            last_submit: {
              provider,
              type
            }
          });
        }
        var _this = this;
        return etask(function* () {
          var user = yield plus_util.login_get_user();
          var email = _this.get_email(opt.email, user);
          return E.before_payment(assign({
            user,
            plan: opt.plan || _this.props.plan,
            cart: opt.cart || _this.props.cart,
            bundle: opt.bundle || _this.props.bundle,
            email,
            coupon: _this.props.coupon,
            vat_obj: _this.state.vat_obj
          }, plus_util.get_currency_o(opt.currency || _this.props.currency, opt.plan || _this.props.plan, _this.state.provider)));
        });
      });
      _defineProperty(this, "after_payment", () => {
        this.setState({
          submitting: false
        });
        if (this.props.after_payment) this.props.after_payment();
      });
      _defineProperty(this, "on_err", e => {
        if (plus_util.api.test_env) console.error(e);
        test_log(Object.keys(e).map(k => `[${k}] ${e[k]}`).join(' '));
        var state = this.state,
          props = this.props;
        if (e.responseText == 'email_used') props.set_email_err('email_used');
        perr({
          id: `www_premium_payment_err`,
          info: {
            method: state.method,
            provider: state.provider,
            type: state.type,
            plan: props.plan && props.plan.id,
            hola_uid: this.get_hola_uid(),
            email: this.get_email(),
            err: e.message || zerr.e2s(e)
          }
        });
      });
      _defineProperty(this, "on_already_plus_err", () => this.setState({
        already_plus_err: true
      }));
      _defineProperty(this, "submit_payment", (type, opt) => {
        var before_payment = this.before_payment,
          after_payment = this.after_payment,
          on_already_plus_err = this.on_already_plus_err,
          on_err = this.on_err,
          avangate_fallback_if = this.avangate_fallback_if,
          _this$props = this.props,
          user = _this$props.user,
          user_email = _this$props.user_email,
          with_trial = _this$props.with_trial;
        var email = this.props.email;
        if (experiment_init.ui_test.test_email_checkout) {
          if (!this.props.user && !email) {
            if (!this.props.email_error) this.props.set_email_err(empty_email_err);
            return {
              error: 'empty_email'
            };
          }
        }
        if (!this.props.check_email()) return {
          error: 'invalid_email'
        };
        var _opt = {
          user,
          user_email: user_email || _.get(user, 'emails[0].value'),
          on_err,
          before_payment,
          after_payment,
          on_already_plus_err,
          avangate_fallback_if,
          with_trial
        };
        if (opt) {
          for (var k in opt) zutil.if_set(opt[k], _opt, k);
        }
        return plus_util.payment_api(type, _opt);
      });
      _defineProperty(this, "get_payment_type", method => {
        var state = this.state,
          _this$props2 = this.props,
          api = _this$props2.api,
          plan = _this$props2.plan,
          script_err = _this$props2.script_err;
        var adyen_disabled = _.get(hopt, 'www_hola.payment.adyen.disabled');
        method = method || state.method;
        switch (method) {
          case 'cc':
            if (api.adyen && !adyen_disabled) {
              return this.check_fallback('cc', {
                provider: 'adyen'
              });
            }
            if (plan.avangate_id && (api.avangate && api.avangate_2pay && !api.is_avangate_fallback || !plan.stripe && !plan.bluesnap)) {
              return this.check_fallback('cc', {
                provider: 'avangate',
                type: '2pay'
              });
            }
            if (plan.avangate_product && (api.avangate && !api.is_avangate_fallback || !plan.stripe && !plan.bluesnap)) {
              return this.check_fallback('cc', {
                provider: 'avangate',
                type: 'plain'
              });
            }
            if (plan.stripe && (api.stripe || !plan.bluesnap)) {
              plus_util.no_test.cc_payment = plus_util.conf.no_stripe || !plan.stripe || script_err['js.stripe.com'];
              if (!plus_util.no_test.cc_payment) {
                return this.check_fallback('cc', {
                  provider: 'stripe',
                  type: 'api'
                });
              }
            }
            if (!plan.bluesnap) return;
            if (api.bluesnap_hpf || !plan.stripe) {
              return this.check_fallback('cc', {
                provider: 'bluesnap',
                type: 'hpf'
              });
            }
            break;
          case 'paypal':
            if (api.use_paypal_api && plan.paypal) {
              return this.check_fallback('paypal', {
                provider: 'paypal',
                type: 'api'
              });
            }
            if (zutil.get(hopt, 'www_hola.paypal_2checkout', false)) {
              return this.check_fallback('paypal', {
                provider: 'avangate',
                type: 'inline'
              });
            }
            return this.check_fallback('paypal', {
              provider: 'paypal',
              type: 'webscr'
            });
          case 'gpay':
            return plan.bluesnap_id && this.check_fallback('gpay', {
              provider: 'bluesnap',
              type: 'gpay'
            });
          case 'applepay':
            return plan.bluesnap_id && this.check_fallback('applepay', {
              provider: 'bluesnap',
              type: 'applepay'
            });
          case 'other':
            return plan.bluesnap_id && this.check_fallback('other', {
              provider: 'bluesnap',
              type: 'apm'
            });
        }
      });
      _defineProperty(this, "get_provider_id", (provider, type) => {
        if (provider == 'bluesnap' && type == 'apm') return 'bluesnap_apm';
        if (provider == 'bluesnap' && type == 'gpay') return 'bluesnap_gpay';
        if (provider == 'bluesnap' && type == 'applepay') return 'bluesnap_applepay';
        return provider;
      });
      _defineProperty(this, "check_fallback", (method, {
        provider,
        type
      }) => {
        var from = [method, provider, type];
        var target, fallback_from, fallback_to;
        for (;;) {
          var id = from.join('-');
          target = this.state.fallback_route[id];
          if (target && this.state.fallback_passed[id]) {
            fallback_from = from;
            fallback_to = target;
          } else {
            var res = {
              provider: from[1],
              type: from[2]
            };
            if (fallback_from) res.fallback = {
              from: fallback_from,
              to: fallback_to
            };
            return res;
          }
          from = target;
        }
      });
      _defineProperty(this, "set_fallback_route", chain => {
        var _this$state = this.state,
          fallback_route = _this$state.fallback_route,
          fallback_passed = _this$state.fallback_passed,
          method = _this$state.method;
        var from, to;
        for (var i = 0; i < chain.length - 1; i++) {
          from = to || chain[i];
          to = chain[i + 1];
          if (from[0] != to[0]) {
            perr({
              id: `www_premium_payment_fallback_wrong`,
              info: {
                from,
                to
              }
            });
          }
          var id = from.join('-');
          if (i == 0) fallback_passed[id] = 1;
          if (fallback_route[id]) continue;
          fallback_route[id] = to;
          var fallbacks = {
            [id]: 1
          };
          var target = to;
          for (;;) {
            if (fallbacks[target.join('-')]) {
              perr({
                id: `www_premium_payment_fallback_looped`,
                info: {
                  fallback_route
                }
              });
              return;
            }
            target = fallback_route[target.join('-')];
            if (!target) break;
          }
        }
        this.setState({
          fallback_route,
          fallback_passed
        });
        if (method == chain[0][0]) this.select_payment(chain[1][0]);
      });
      _defineProperty(this, "select_payment", method => {
        var state = this.state,
          _this$props3 = this.props,
          api = _this$props3.api,
          plan = _this$props3.plan,
          disable_scroll_to_top = _this$props3.disable_scroll_to_top;
        if (!sys.mobile && !disable_scroll_to_top) window.scrollTo(0, 0);
        var _ref3 = this.get_payment_type(method) || {},
          provider = _ref3.provider,
          type = _ref3.type;
        if (provider && type) {
          api[provider] = 1;
          api[provider + '_' + type] = 1;
        }
        if (!provider && method != 'cc') return void this.select_payment('cc');
        if (state.method == method && state.provider == provider && state.type == type) {
          return;
        }
        var provider_id = this.get_provider_id(provider, type);
        perr({
          id: `www_premium_payment_select_${provider_id}`,
          info: {
            method,
            type,
            plan_id: plan.id,
            period: plan.period,
            hola_uid: this.get_hola_uid()
          }
        });
        eec.add_to_cart([{
          id: plan.id,
          name: plan.name,
          price: plan.price,
          category: 'vpn-b2c',
          list: 'Plus page plans'
        }]);
        gtm.push({
          event: 'select_payment_option',
          provider_id
        });
        this.setState({
          method,
          provider,
          type
        });
        if (method == 'cc') focus_first_card();
        if (this.props.on_method_tab_change) this.props.on_method_tab_change(method, provider);
      });
      _defineProperty(this, "on_change_currency", value => {
        this.props.set_currency(value);
      });
      _defineProperty(this, "set_vat_obj", (vat_obj, vat_loading = false) => {
        this.setState({
          vat_obj,
          vat_loading
        });
        if (this.props.on_vat_obj_change) this.props.on_vat_obj_change(vat_obj);
      });
      _defineProperty(this, "set_vat_loading", () => this.set_vat_obj(undefined, true));
      _defineProperty(this, "unset_vat_obj", () => this.set_vat_obj(undefined, false));
      _defineProperty(this, "on_load", () => {
        clearTimeout(this.form_loading_timer);
        if (this.props.on_load) this.props.on_load();
      });
      _defineProperty(this, "on_email_key_down", ev => {
        if (ev.key == 'Tab') return E.emitter.emit('email_passed_focus', {
          state: this.state
        });
        if (ev.key == 'Enter') return E.emitter.emit('submit_requested', {
          state: this.state
        });
      });
      _defineProperty(this, "last_submit_is", (provider, type) => {
        var ls = this.state.last_submit;
        return ls && ls.provider == provider && (!type || ls.type == type);
      });
    }
    componentDidMount() {
      var _this = this;
      E.start_checkout();
      var payment_order = get_payment_order();
      this.select_payment(payment_order && payment_order[0] || 'cc');
      var email = qs_o().email;
      if (email && !this.props.email && !plus_util.validate_email_syntax(email)) {
        this.props.set_email(email);
      }
      this.form_loading_timer = setTimeout(() => {
        var _this$props$plan;
        var info = {
          plan_id: (_this$props$plan = this.props.plan) === null || _this$props$plan === void 0 ? void 0 : _this$props$plan.id,
          user_email: this.props.user_email || _.get(this.props.user, 'emails[0].value')
        };
        perr({
          id: 'www_premium_payment_loading_over_10s',
          info
        });
      }, 10000);
      if (this.props.api.gpay) {
        etask(function* () {
          var res = yield init_gpay(_this.props.on_script_load_err);
          if (res && res.err) {
            test_log('google pay not ready');
            if (_this.state.method == 'gpay') {
              _this.setState({
                method: payment_order.find(po => po != 'gpay')
              });
            }
            _this.setState({
              gpay_err: res.err
            });
          } else test_log('google pay ready');
        });
      }
      if (this.props.api.applepay) {
        etask(function* () {
          var res = yield is_supports_applepay();
          test_log('apple pay', res ? 'supported' : 'not supported');
          if (!res) {
            _this.setState({
              applepay_not_supported: true
            });
            if (_this.state.method == 'applepay') {
              _this.setState({
                method: payment_order.find(po => po != 'applepay')
              });
            }
          } else _this.setState({
            applepay_not_supported: false
          });
        });
      }
    }
    componentDidUpdate(prev_props, prev_state) {
      if (this.props.slide_active && !prev_props.slide_active) focus_first_card();
      if (this.props.plan && prev_props.plan && this.props.plan.id != prev_props.plan.id) {
        this.select_payment(this.state.method || 'cc');
      }
    }
    render() {
      var state = this.state;
      var _this$state2 = this.state,
        submitting = _this$state2.submitting,
        method = _this$state2.method,
        already_plus_err = _this$state2.already_plus_err,
        vat_obj = _this$state2.vat_obj,
        vat_loading = _this$state2.vat_loading,
        last_submit = _this$state2.last_submit,
        provider = _this$state2.provider,
        type = _this$state2.type,
        fallback = _this$state2.fallback,
        props = this.props;
      var plan = props.plan,
        go_back = props.go_back,
        set_plan = props.set_plan,
        api = props.api,
        email = props.email,
        user = props.user,
        script_err = props.script_err,
        set_coupon = props.set_coupon,
        coupon = props.coupon,
        email_error = props.email_error,
        only_right_part = props.only_right_part,
        no_header = props.no_header,
        no_legal = props.no_legal,
        input_small = props.input_small,
        legal_tiny_size = props.legal_tiny_size,
        email_in_cc = props.email_in_cc,
        hidden_checkout = props.hidden_checkout,
        legal_before_btn = props.legal_before_btn,
        on_change_view = props.on_change_view,
        no_currency_selector = props.no_currency_selector,
        before_btn_component = props.before_btn_component,
        is_hola2023 = props.is_hola2023,
        applied_coupon = props.applied_coupon,
        apply_coupon = props.apply_coupon,
        summary_test = props.summary_test,
        is_client = props.is_client,
        with_skeleton = props.with_skeleton,
        secured_elems_test = props.secured_elems_test,
        payment_btn_on_top = props.payment_btn_on_top,
        checkout_text_test = props.checkout_text_test,
        with_trial = props.with_trial;
      var _plus_util$get_curren = plus_util.get_currency_o(props.currency, plan, provider),
        currency = _plus_util$get_curren.currency,
        currencies = _plus_util$get_curren.currencies;
      if (plan.id == 'free') return null;
      var price_o = zmembership.get_price_plan(plan, currency);
      var base_plan_id = plan.base_plan;
      var base_plan = base_plan_id && plans_util.get_plan_info(base_plan_id);
      var base_price_o = base_plan && zmembership.get_price_plan(base_plan, currency) || {};
      api.payment_method = {
        method,
        provider,
        type
      };
      if (method && api.test_env) {
        if (!logged_payment_method || logged_payment_method != JSON.stringify({
          method,
          provider,
          type,
          plan
        })) {
          test_log('method', method, 'provider', provider, 'type', type, 'plan', plan);
          logged_payment_method = JSON.stringify({
            method,
            provider,
            type,
            plan
          });
        }
      }
      var _ref4 = plan || {},
        period = _ref4.period,
        short_name = _ref4.short_name;
      var _ref5 = price_o || {},
        price = _ref5.price,
        month_price = _ref5.month_price;
      var plan_name = period == '3 Y' ? '3-year ' : short_name;
      var experiment_cta = with_trial ? 'Try free for 3 days' : hopt.www_hola.cta_for_experiment || 'Buy now';
      var buy_or_checkout = experiment_cta;
      var submit_caption = method == 'other' ? 'Pay with alternative method' : buy_or_checkout;
      var opt = assign({
        plan,
        currency,
        submitting,
        api,
        set_plan,
        email,
        user,
        already_plus_err,
        fallback,
        vat_obj,
        provider,
        last_submit,
        coupon,
        set_coupon,
        applied_coupon,
        apply_coupon,
        email_error,
        no_legal,
        input_small,
        summary_test,
        payment_btn_on_top,
        legal_tiny_size,
        hidden_checkout,
        email_in_cc,
        legal_before_btn,
        on_change_view,
        no_currency_selector,
        checkout_text_test,
        before_btn_component,
        secured_elems_test,
        with_trial,
        theme: this.context ? this.context.theme : {},
        submit_caption,
        theme_name: this.context ? this.context.theme_name : 'default'
      }, _.pick(props, 'set_currency', 'set_plans', 'check_email', 'plans', 'set_email_err', 'user_email', 'on_script_load_err', 'set_email', 'country'), _.pick(this, 'get_email', 'submit_payment', 'before_payment', 'after_payment', 'set_fallback_route', 'select_payment', 'submit_avangate', 'set_vat_obj', 'set_vat_loading', 'unset_vat_obj', 'on_err', 'avangate_fallback_if', 'last_submit_is', 'on_email_key_down', 'get_hola_uid', 'set_submitting'));
      var vat = get_vat_res(vat_obj, price, provider);
      if (vat) price = vat.price;
      var show_retry_msg = method == 'cc' && script_err['2pay.js'] && script_err['bluesnap.js'];
      var payment_order = get_payment_order();
      var items = [];
      payment_order.forEach(id => {
        if (id == 'cc') return items.push({
          id,
          title: 'Credit Card'
        });
        if (with_trial) return;
        if (id == 'paypal') {
          return items.push({
            id,
            title: 'PayPal',
            hide: script_err['paypal.com/sdk/js']
          });
        }
        if (id == 'applepay') {
          return items.push({
            id,
            title: 'Apple Pay',
            hide: !api.applepay || !plan.bluesnap || state.applepay_not_supported
          });
        }
        if (id == 'gpay') {
          return items.push({
            id,
            title: 'Google Pay',
            hide: !api.gpay || !plan.bluesnap || state.gpay_err || script_err['pay.google.com']
          });
        }
        if (id == 'other') return items.push({
          id,
          title: 'Other',
          hide: !plan.bluesnap
        });
      });
      var current_method = items.find(it => it.id == method);
      if (current_method && current_method.hide) method = items.filter(it => !it.hide)[0].id;
      if (provider == 'bluesnap' && !plan.bluesnap) provider = 'stripe';
      var is_cc_stripe = method == 'cc' && provider == 'stripe' && type == 'api';
      var is_cc_bluesnap_hpf = method == 'cc' && provider == 'bluesnap' && type == 'hpf';
      var need_email_field = api.avangate || provider != 'avangate' || experiment_init.ui_test.test_email_checkout;
      var qs = qs_o();
      if (qs.open_suspect_dlg) susp_dlg('test_susp', is_hola2023);
      if (qs.open_error_dlg) err_dlg('test_err', is_hola2023);
      if (!with_skeleton && !is_client) return /*#__PURE__*/React.createElement(Fragment, null);
      if (is_hola2023) {
        return /*#__PURE__*/React.createElement("div", {
          className: cn('step-payment--hola2023', summary_test && 'with_summary', 'with_credit_cards_icons')
        }, /*#__PURE__*/React.createElement(Tab_buttons, {
          items: items,
          on_change: new_method => this.select_payment(new_method),
          active: method || 'cc',
          class_name: "payment_method_tabs--hola2023"
        }), !with_skeleton || is_client ? /*#__PURE__*/React.createElement(Fragment, null, !!api.avangate && /*#__PURE__*/React.createElement(CC_2checkout, _extends({}, opt, {
          on_load: this.on_load,
          hide_country: true,
          show: method == 'cc' && provider == 'avangate' && type == '2pay',
          with_skeleton: with_skeleton
        })), !!api.stripe && /*#__PURE__*/React.createElement(CC_stripe, _extends({}, opt, {
          on_load: this.on_load,
          show: is_cc_stripe,
          with_skeleton: with_skeleton
        })), !!api.adyen && /*#__PURE__*/React.createElement(CC_adyen, _extends({}, opt, {
          on_load: this.on_load,
          btn_props: {
            tab_index: '38',
            cls: 'submit_btn'
          },
          set_fallback_route: () => {
            plus_util.api.adyen = false;
            plus_util.api.stripe = true;
            this.select_payment('cc');
          },
          Skeleton_comp: Card_skeleton,
          show: method == 'cc',
          with_skeleton: with_skeleton
        })), !!api.bluesnap_hpf && /*#__PURE__*/React.createElement(CC_bluesnap_hpf, _extends({}, opt, {
          on_load: this.on_load,
          show: is_cc_bluesnap_hpf,
          with_skeleton: with_skeleton
        })), provider == 'avangate' && type == 'plain' && /*#__PURE__*/React.createElement(Avangate_payment, _extends({}, opt, {
          show: true,
          with_skeleton: with_skeleton
        })), method == 'paypal' && provider == 'paypal' && type == 'webscr' && /*#__PURE__*/React.createElement(Paypal_payment_webscr, _extends({}, opt, {
          show: true
        })), /*#__PURE__*/React.createElement(Paypal_payment_api, _extends({}, opt, {
          show: method == 'paypal' && provider == 'paypal' && type == 'api'
        })), !!api.gpay && method == 'gpay' && provider == 'bluesnap' && /*#__PURE__*/React.createElement(Bluesnap_gpay, _extends({}, opt, {
          show: true
        })), !!api.applepay && method == 'applepay' && provider == 'bluesnap' && /*#__PURE__*/React.createElement(Bluesnap_applepay, _extends({}, opt, {
          show: true
        })), method == 'other' && provider == 'bluesnap' && /*#__PURE__*/React.createElement(Bluesnap_apm_payment, _extends({}, opt, {
          show: true
        }))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CC_stripe_fake, opt)));
      }
      if (with_skeleton && !is_client) {
        return /*#__PURE__*/React.createElement("div", {
          className: cn('step step-payment')
        }, /*#__PURE__*/React.createElement(Card_skeleton, {
          abs: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: cn('step step-payment')
      }, state.avangate_notice && submitting && ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
        className: "avangate_notice"
      }, /*#__PURE__*/React.createElement("span", null, "There was an error, please try again")), document.getElementById('react-root')), !no_header && /*#__PURE__*/React.createElement(E.Checkout_header, {
        go_back: go_back,
        base_price_o: base_price_o,
        vat_loading: vat_loading,
        vat: vat,
        month_price: month_price,
        plan_name: plan_name,
        currency: currency,
        price: price,
        plan_id: plan && plan.id,
        every: plan && plan.every,
        free_period: plan && plan.free_period,
        renewal_price: plan && plan.renewal_price
      }), /*#__PURE__*/React.createElement(Tab_buttons, {
        items: items,
        active: method,
        on_change: new_method => this.select_payment(new_method),
        class_name: cn('payment_method_tabs', props.payment_tabs_margin_v2 && 'payment_method_tabs--margin_v2')
      }), /*#__PURE__*/React.createElement("div", {
        className: "payment-method-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkout"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step-payment-sel"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step-header-title with-currency"
      }, !no_currency_selector && currencies.length > 1 && /*#__PURE__*/React.createElement(Currency_select, {
        only_right_part: only_right_part,
        cls: 'absolute_currency_select',
        currency: currency,
        on_change: this.on_change_currency,
        currencies: currencies
      })), /*#__PURE__*/React.createElement("div", {
        className: cn('payment-method-form', 'form-' + provider, 'form-' + provider + '-' + type, submitting && 'submitting-form')
      }, /*#__PURE__*/React.createElement(Already_premium_warning, _extends({}, opt, {
        on_toggle_premium_warning: props.on_toggle_premium_warning
      }), !user && !['gpay', 'other'].includes(method) && need_email_field && (!email_in_cc || method != 'cc') && /*#__PURE__*/React.createElement(Input, {
        cl: "email_field",
        size: input_small ? 'sm' : undefined,
        onKeyDown: this.on_email_key_down,
        on_change_validation: false,
        name: "email",
        auto_complete: "email",
        value: email,
        validator: plus_util.email_validator,
        inputmode: "email",
        placeholder: "name@example.com",
        label: "Email",
        on_validation: props.set_email_err,
        error: email_error,
        on_change: props.set_email,
        tab_index: 1
      }), !!api.stripe && /*#__PURE__*/React.createElement(CC_stripe, _extends({}, opt, {
        on_load: this.on_load,
        show: is_cc_stripe
      })), !!api.bluesnap_hpf && /*#__PURE__*/React.createElement(CC_bluesnap_hpf, _extends({}, opt, {
        on_load: this.on_load,
        show: is_cc_bluesnap_hpf
      })), !!api.avangate && /*#__PURE__*/React.createElement(CC_2checkout, _extends({}, opt, {
        on_load: this.on_load,
        hide_country: true,
        show: method == 'cc' && provider == 'avangate' && type == '2pay'
      })), provider == 'avangate' && type == 'plain' && /*#__PURE__*/React.createElement(Avangate_payment, _extends({}, opt, {
        show: true
      })), method == 'paypal' && provider == 'paypal' && type == 'webscr' && /*#__PURE__*/React.createElement(Paypal_payment_webscr, _extends({}, opt, {
        show: true
      })), /*#__PURE__*/React.createElement(Paypal_payment_api, _extends({}, opt, {
        show: method == 'paypal' && provider == 'paypal' && type == 'api'
      })), !!api.gpay && method == 'gpay' && provider == 'bluesnap' && /*#__PURE__*/React.createElement(Bluesnap_gpay, _extends({}, opt, {
        show: true
      })), !!api.applepay && method == 'applepay' && provider == 'bluesnap' && /*#__PURE__*/React.createElement(Bluesnap_applepay, _extends({}, opt, {
        show: true
      })), method == 'other' && provider == 'bluesnap' && /*#__PURE__*/React.createElement(Bluesnap_apm_payment, _extends({}, opt, {
        show: true
      })), show_retry_msg && /*#__PURE__*/React.createElement("div", {
        className: "retry-msg"
      }, "There was an error loading the page. ", /*#__PURE__*/React.createElement("a", {
        onClick: () => location.reload()
      }, "Reload"))))))));
    }
  }, _defineProperty(_Class, "contextType", Settings_context), _Class);
  E.Step_payment = function Step_payment(props) {
    var _useState55 = useState(hopt.cookie_value_parsed && hopt.cookie_value_parsed.n),
      _useState56 = _slicedToArray(_useState55, 2),
      cookie_ready = _useState56[0],
      set_cookie_ready = _useState56[1];
    var _useContext1 = useContext(App_context),
      is_client = _useContext1.is_client;
    useEffect(() => {
      if (!cookie_ready) {
        etask(function* () {
          yield wait_for_download_scripts();
          set_cookie_ready(true);
        });
      }
    }, []);
    if (!cookie_ready) return /*#__PURE__*/React.createElement(Fragment, null);
    return /*#__PURE__*/React.createElement(Step_payment_internal, _extends({}, props, {
      is_client: is_client
    }));
  };
  var Paypal_payment_webscr = props => {
    var _useContext10 = useContext(Settings_context),
      theme_name = _useContext10.theme_name;
    var is_hola2023 = theme_name != 'default';
    var is_bb = theme_name === 'browserai';
    return /*#__PURE__*/React.createElement("div", {
      className: 'step-payment-item paypal' + (props.show ? '' : ' hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, !props.user && is_hola2023 && /*#__PURE__*/React.createElement(Input, {
      cl: "paypal-email-field",
      onKeyDown: props.on_email_key_down,
      auto_focus: true,
      on_change_validation: false,
      name: "email",
      auto_complete: "email",
      value: props.email,
      validator: plus_util.email_validator,
      inputmode: "email",
      placeholder: is_bb ? 'Enter your email' : 'name@example.com',
      label: "Email",
      on_validation: props.set_email_err,
      error: props.email_error,
      on_change: props.set_email
    }), !props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "paypal_promo"
    })), props.before_btn_component, !props.no_legal && props.legal_before_btn && /*#__PURE__*/React.createElement(Legal, props), /*#__PURE__*/React.createElement(Paypal_payment_btn, props), props.payment_btn_on_top && !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "paypal_promo"
    })), !props.no_legal && !props.legal_before_btn && /*#__PURE__*/React.createElement(Legal, props)));
  };
  var Bluesnap_apm_payment = props => {
    if (!props.api.use_bluesnap_apm) return null;
    var _useContext11 = useContext(Settings_context),
      theme = _useContext11.theme,
      theme_name = _useContext11.theme_name;
    var is_hola2023 = theme_name != 'default';
    var submitting = props.submitting && props.last_submit_is('bluesnap', 'apm');
    var btn_cls = cn('hola_btn hola_btn--round hola_btn--w100', submitting && 'submitting', props.hidden_checkout && 'hidden_checkout');
    var desc_cls = is_hola2023 ? cn(theme.p3, theme.med, 'desc_title') : '';
    return /*#__PURE__*/React.createElement("div", {
      className: 'step-payment-item other' + (props.show ? '' : ' hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "description"
    }, /*#__PURE__*/React.createElement("p", {
      className: desc_cls
    }, "We accept alternative payment methods such as:"), /*#__PURE__*/React.createElement(Other_pms, null)), !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "other_promo"
    })), props.before_btn_component, is_hola2023 ? /*#__PURE__*/React.createElement(With_legal, props, /*#__PURE__*/React.createElement(Button, {
      disabled: submitting,
      arrow: true,
      caption: props.submit_caption,
      cls: "submit_btn",
      on_click: () => {
        send_submit_event();
        props.submit_payment('bluesnap_apm');
      },
      tab_index: "38"
    })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      disabled: submitting,
      onClick: () => {
        send_submit_event();
        props.submit_payment('bluesnap_apm');
      },
      tabIndex: "38"
    }, submitting && /*#__PURE__*/React.createElement(Spinner, null), !submitting && /*#__PURE__*/React.createElement("span", null, "Continue")), !props.no_legal && /*#__PURE__*/React.createElement(Legal, props))));
  };
  var Bluesnap_gpay = props => {
    var _useContext12 = useContext(Settings_context),
      theme_name = _useContext12.theme_name;
    var is_hola2023 = theme_name != 'default';
    var _useState57 = useState(null),
      _useState58 = _slicedToArray(_useState57, 2),
      gpay_client = _useState58[0],
      set_gpay_client = _useState58[1];
    var _useState59 = useState(null),
      _useState60 = _slicedToArray(_useState59, 2),
      err = _useState60[0],
      set_err = _useState60[1];
    var submitting = props.submitting && props.last_submit_is('bluesnap', 'gpay');
    useEffect(() => {
      etask(function* () {
        var res = yield init_gpay(props.on_script_load_err);
        if (res && res.ready) set_gpay_client(res.client);
      });
    }, []);
    var on_click = () => etask(function* () {
      if (submitting) return;
      send_submit_event();
      if (experiment_init.ui_test.test_email_checkout) {
        if (!props.user && !props.email) {
          if (!props.email_error) props.set_email_err(empty_email_err);
          return;
        }
      }
      if (!(yield props.check_email())) return;
      set_err(null);
      var merchant_info = {
        merchantId: 'BCR2DN6TSOQ6J3LM',
        merchantName: 'Hola Ltd.'
      };
      var parameters = {
        gateway: 'bluesnap',
        gatewayMerchantId: bs_merchant_id
      };
      var request = assign({}, gpay_base_request, {
        emailRequired: true,
        merchantInfo: merchant_info,
        allowedPaymentMethods: [assign({}, gpay_base_card_pm, {
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters
          }
        })]
      });
      var _plus_util$get_curren2 = plus_util.get_currency_o(props.currency, props.plan, 'bluesnap'),
        currency = _plus_util$get_curren2.currency;
      var price_o = zmembership.get_price_plan(props.plan, currency);
      var trans_info = {
        totalPriceStatus: 'FINAL',
        totalPrice: '' + price_o.price,
        currencyCode: currency,
        countryCode: hopt.user_country
      };
      request.transactionInfo = trans_info;
      perr({
        id: 'www_premium_payment_submit_clicked_bluesnap_gpay',
        info: {
          merchant_info,
          parameters,
          trans_info
        }
      });
      gpay_client.loadPaymentData(request).then(payment_data => new Promise((resolve, reject) => {
        etask(function* () {
          try {
            yield process_payment(payment_data);
            resolve();
          } catch (e) {
            reject(e);
          }
        });
      })).catch(e => {
        var err_msg = submit_err_render(e);
        if (e.statusCode == 'CANCELED') return;
        perr({
          id: 'www_premium_payment_bluesnap_gpay_err',
          info: {
            err: {
              msg: err_msg,
              code: e.statusCode,
              desc: e.statusMessage
            },
            request
          }
        });
        set_err(err_msg);
        if (qs_o().debug_suspect_dlg) susp_dlg('bluesnap_gpay_susp', is_hola2023);
        if (!props.avangate_fallback_if(bluesnap_avangate_fallback_cond(e), plus_util.get_err_text(e))) {
          err_dlg('bluesnap_gpay', is_hola2023);
        }
      });
    });
    var process_payment = data => {
      if (!data) return;
      var google_pay_token = b64_encode_unicode(JSON.stringify(data));
      var email = data.email;
      if (qs_o().no_submit) return void test_log('google pay data', data);
      return props.submit_payment('bluesnap_gpay', {
        google_pay_token,
        email,
        google_pay_email: email
      });
    };
    var btn_cls = cn('hola_btn hola_btn--round google-pay-btn-center', 'hola_btn--black google-pay', submitting && 'submitting', is_hola2023 && 'hola_btn--no_jump');
    var img_src = submitting && !is_hola2023 ? 'google_pay_disabled.svg' : 'google_pay_btn.svg';
    return /*#__PURE__*/React.createElement("div", {
      className: 'step-payment-item gpay' + (props.show ? '' : ' hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "google_pay_promo"
    })), err && /*#__PURE__*/React.createElement("div", {
      className: "alert-danger alert"
    }, err), props.before_btn_component, props.legal_before_btn && /*#__PURE__*/React.createElement(Legal, props), gpay_client && /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      disabled: submitting,
      onClick: on_click,
      tabIndex: "38"
    }, submitting && !is_hola2023 && /*#__PURE__*/React.createElement(Spinner, null), (!submitting || is_hola2023) && /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url(img_src),
      alt: "img_src",
      className: "lazyload"
    })), !props.legal_before_btn && !props.no_legal && /*#__PURE__*/React.createElement(Legal, props)));
  };
  var get_plan_label = plan => 'Hola ' + (plan.type == 'ultra' ? 'Ultra' : 'Premium') + ' - ' + plan.name + ' ' + (('' + plan.name).toLowerCase().includes('plan') ? '' : ' Plan');
  var Bluesnap_applepay = props => {
    var plan = props.plan,
      before_btn_component = props.before_btn_component;
    var _useContext13 = useContext(Settings_context),
      theme_name = _useContext13.theme_name;
    var is_hola2023 = theme_name != 'default';
    var _useState61 = useState(null),
      _useState62 = _slicedToArray(_useState61, 2),
      err = _useState62[0],
      set_err = _useState62[1];
    var email = props.email,
      email_error = props.email_error,
      after_payment = props.after_payment;
    var _useState63 = useState(false),
      _useState64 = _slicedToArray(_useState63, 2),
      loading = _useState64[0],
      set_loading = _useState64[1];
    var submitting = props.submitting && props.last_submit_is('bluesnap', 'applepay') || loading;
    var on_click = () => {
      send_submit_event();
      if (submitting) return;
      if (!props.user && (!email || email_error)) return props.set_email_err(email_error || empty_email_err);
      if (!window.ApplePaySession) return;
      set_loading(true);
      set_err(null);
      var _plus_util$get_curren3 = plus_util.get_currency_o(props.currency, plan, 'bluesnap'),
        currency = _plus_util$get_curren3.currency;
      var price_o = zmembership.get_price_plan(plan, currency);
      var label = get_plan_label(plan);
      var request = {
        countryCode: hopt.user_country,
        currencyCode: currency,
        total: {
          label,
          amount: '' + price_o.price,
          type: 'final'
        },
        supportedNetworks: ['amex', 'discover', 'jcb', 'masterCard', 'visa'],
        merchantCapabilities: ['supports3DS'],
        requiredBillingContactFields: ['name'],
        requiredShippingContactFields: ['email']
      };
      if (window.debug_applepay_request) assign(request, window.debug_applepay_request);
      perr({
        id: 'www_premium_payment_submit_clicked_bluesnap_applepay',
        info: {
          request
        }
      });
      var session_aborted;
      var session = new window.ApplePaySession(2, request);
      session.onvalidatemerchant = event => etask(function* () {
        var body = {
          validation_url: event.validationURL,
          domain: window.location.hostname,
          label,
          bundle: props.bundle
        };
        if (plus_util.api.test_env) body.sbx = 1;
        try {
          var res = yield $.post('/users/payment/bluesnap_create_wallet', body);
          if (!session_aborted) {
            session.completeMerchantValidation(JSON.parse(atob(res.walletToken)));
          }
        } catch (e) {
          console.error('applepay error', e);
          set_err('Unexpected error, please try another payment method');
          session.abort();
        }
      });
      session.onpaymentauthorized = event => etask(function* () {
        if (qs_o().no_submit) return void test_log('apple pay data', event);
        try {
          yield props.submit_payment('bluesnap_applepay', {
            session,
            apple_pay_token: b64_encode_unicode(JSON.stringify(event.payment)),
            apple_pay_email: _.get(event, 'payment.shippingContact.emailAddress'),
            apple_pay_payment_method: _.get(event, 'payment.token.paymentMethod.displayName')
          });
          set_loading(false);
          after_payment();
        } catch (e) {
          var err_msg = submit_err_render(e);
          session.abort();
          if (e.statusCode == 'CANCELED') return;
          perr({
            id: 'www_premium_payment_bluesnap_applepay_err',
            info: {
              err: {
                msg: err_msg,
                code: e.statusCode,
                desc: e.statusMessage
              },
              request
            }
          });
          set_err(err_msg);
          if (qs_o().debug_suspect_dlg) susp_dlg('bluesnap_applepay_susp', is_hola2023);
          if (!props.avangate_fallback_if(bluesnap_avangate_fallback_cond(e), plus_util.get_err_text(e))) {
            err_dlg('bluesnap_applepay', is_hola2023);
          }
        }
      });
      session.oncancel = () => {
        session_aborted = true;
        set_loading(false);
        after_payment();
      };
      session.begin();
    };
    var btn_cls = cn('hola_btn hola_btn--round hola_btn--w100', 'hola_btn--black apple-pay', props.submitting && 'submitting', props.hidden_checkout && 'hidden_checkout');
    return /*#__PURE__*/React.createElement("div", {
      className: 'step-payment-item applepay' + (props.show ? '' : ' hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, !props.summary_test && /*#__PURE__*/React.createElement(Checkout_promo, _extends({}, props, {
      id: "apple_pay_promo"
    })), before_btn_component, err && /*#__PURE__*/React.createElement("div", {
      className: "alert-danger alert"
    }, err), /*#__PURE__*/React.createElement("button", {
      className: btn_cls,
      disabled: submitting,
      onClick: on_click,
      tabIndex: "38"
    }, submitting && /*#__PURE__*/React.createElement(Spinner, null), !submitting && /*#__PURE__*/React.createElement("img", {
      src: plus_util.img_url('apple_pay_btn.svg'),
      className: "lazyload"
    })), !props.no_legal && /*#__PURE__*/React.createElement(Legal, props)));
  };
  var Redeem_code = ({
    email,
    on_cancel,
    modal,
    hide_agree,
    on_continue
  }) => {
    var _useState65 = useState(''),
      _useState66 = _slicedToArray(_useState65, 2),
      code_error = _useState66[0],
      set_code_error = _useState66[1];
    var _useState67 = useState(false),
      _useState68 = _slicedToArray(_useState67, 2),
      must_agree = _useState68[0],
      set_must_agree = _useState68[1];
    var _useState69 = useState(false),
      _useState70 = _slicedToArray(_useState69, 2),
      busy = _useState70[0],
      set_busy = _useState70[1];
    var _useState71 = useState(''),
      _useState72 = _slicedToArray(_useState71, 2),
      code = _useState72[0],
      set_code = _useState72[1];
    var _useState73 = useState(!!hide_agree),
      _useState74 = _slicedToArray(_useState73, 2),
      agree = _useState74[0],
      set_agree = _useState74[1];
    useEffect(() => {
      perr({
        id: 'www_premium_redeem_code_show'
      });
    }, []);
    var on_change = ev => set_code(ev.target.value);
    var click_agree = () => {
      perr({
        id: 'www_premium_redeem_code_click_agree'
      });
      var new_val = !agree;
      set_agree(new_val);
      if (must_agree && new_val) set_must_agree(false);
    };
    var on_redeem = () => etask(function* () {
      this.finally(() => set_busy(false));
      set_busy(true);
      perr({
        id: 'www_premium_redeem_code_click_redeem',
        info: {
          email,
          code,
          agree
        }
      });
      if (!code) return void set_code_error('Please enter license code');
      set_code_error('');
      if (!agree) return void set_must_agree(true);
      try {
        var res = yield $.post('/users/payment/coupon', {
          email,
          code,
          ref: plus_util.get_url_ref(),
          uuid: be.get_uuid()
        });
        if (on_continue) {
          return on_continue({
            currency: res && res.currency || null,
            coupon: code
          });
        }
        perr({
          id: 'www_premium_redeem_code_success',
          info: {
            email,
            code,
            agree
          }
        });
        location.href = plus_util.after_payment_page({
          coupon: 1,
          email
        });
      } catch (e) {
        set_code_error(e && plus_util.redeem_errors[e.responseText] || 'We\'ve encountered an error. Please try again later');
        perr({
          id: 'www_premium_redeem_code_err',
          info: {
            err: zerr.e2s(e)
          }
        });
      }
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "row redeem-code"
    }, /*#__PURE__*/React.createElement("div", {
      className: modal ? 'col-xs-12' : 'col-sm-8 col-md-6'
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('form-group', code_error && 'has-error')
    }, /*#__PURE__*/React.createElement("label", {
      className: "code-label",
      htmlFor: "code"
    }, /*#__PURE__*/React.createElement("span", null, "Enter your license code: ")), /*#__PURE__*/React.createElement("input", {
      id: "code",
      className: "form-control input-lg",
      name: "code",
      value: code,
      onChange: on_change
    }), code_error && /*#__PURE__*/React.createElement("div", {
      className: "error"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-warning-sign"
    })), /*#__PURE__*/React.createElement("label", {
      htmlFor: "code"
    }, code_error))), !hide_agree && /*#__PURE__*/React.createElement("div", {
      className: "checkbox"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: agree,
      onChange: click_agree
    }), "I agree to Hola ", /*#__PURE__*/React.createElement("a", {
      href: "/legal/sla",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
      href: "/legal/privacy",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Privacy Policy"))), must_agree && /*#__PURE__*/React.createElement("div", {
      className: "error"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-warning-sign"
    })), /*#__PURE__*/React.createElement("label", null, "Please agree to terms and conditions")), /*#__PURE__*/React.createElement("div", {
      className: "buttons"
    }, /*#__PURE__*/React.createElement("button", {
      className: "btn-redeem hola_btn hola_btn--round hola_btn--w100",
      onClick: on_redeem,
      disabled: busy
    }, "Redeem a Code"), on_cancel && /*#__PURE__*/React.createElement("button", {
      className: "btn-cancel",
      onClick: on_cancel
    }, "Cancel"))));
  };
  E.Step_redeem = function Step_redeem(opt) {
    return /*#__PURE__*/React.createElement("div", {
      className: "step step-redeem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-header-title"
    }, "Redeem a code"), /*#__PURE__*/React.createElement(Redeem_code, opt));
  };
  E.Plan_info = function Plan_info(props) {
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    var best = props.best,
      set_plan = props.set_plan,
      plan = props.plan,
      currency = props.currency;
    var cls = cn('plan_info', best.id == plan.id && 'plan_info--best');
    var price_o = zmembership.get_price_plan(plan, currency);
    var month_price = price_o.month_price,
      price = price_o.price,
      discount_percent = price_o.discount_percent;
    var every = plan.every;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("div", {
      className: "plan_header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plan_header__title"
    }, /*#__PURE__*/React.createElement(Trans, null, plan.short_name, " plan")), discount_percent && /*#__PURE__*/React.createElement("div", {
      className: "plan_header__best_container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plan_header__best"
    }, /*#__PURE__*/React.createElement(Trans, null, "Save"), " ", discount_percent, "%"))), /*#__PURE__*/React.createElement("div", {
      className: "plan_info__buy_row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plan_price"
    }, zcountry.format_price(currency, month_price), /*#__PURE__*/React.createElement("span", {
      className: "plan_price__label"
    }, ' ', "/ ", t('month'))), /*#__PURE__*/React.createElement("button", {
      onClick: () => set_plan(plan),
      className: "hola_btn plan_info__button hola_btn--round hola_btn--sm"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Trans, null, "Buy Now")))), /*#__PURE__*/React.createElement("div", {
      className: "plan_info__every_block"
    }, zcountry.format_price(currency, price), " ", /*#__PURE__*/React.createElement(Trans, null, "billed ", every == 'month' ? 'monthly' : `every ${every}`)));
  };
  E.Plus_plans_tabs = function Plus_plans_tabs(props) {
    var plans = props.plans,
      best = props.best;
    var history = useHistory();
    var _useState75 = useState(qs_o().pid),
      _useState76 = _slicedToArray(_useState75, 2),
      qs_plan_id = _useState76[0],
      set_qs_plan_id = _useState76[1];
    var select_plan = _id => {
      set_qs_plan_id(_id);
      var new_url = zurl.qs_add(location.href, {
        pid: _id
      }, {
        safe: true
      });
      history.push(new_url.split(location.host)[1]);
    };
    var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;
    var items = useMemo(() => {
      return plans.map(p => {
        return {
          id: p.id,
          title: p.id == best.id ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
            className: "payment_best_container"
          }, /*#__PURE__*/React.createElement("span", {
            className: "payment_best_label"
          }, /*#__PURE__*/React.createElement("img", {
            src: url2md5('/www/hola/pub/img/mascot/best_holi.png'),
            className: cn('payment_best_label_holi', 'lazyload'),
            alt: "best_holi"
          }), /*#__PURE__*/React.createElement("img", {
            src: url2md5(`/www/hola/pub/img/${t('best_text')}.svg`),
            alt: "best_text",
            className: cn('payment_best_label_text', 'lazyload')
          })), /*#__PURE__*/React.createElement(Trans, null, p.short_name))) : /*#__PURE__*/React.createElement(Trans, null, p.short_name)
        };
      });
    }, [plans]);
    var active_plan_id = qs_plan_id || items[0] && items[0].id;
    var active_plan = plans.find(p => p.id == active_plan_id);
    return /*#__PURE__*/React.createElement(Fragment, null, items.length && /*#__PURE__*/React.createElement(Tab_buttons, {
      items: items,
      active: active_plan_id,
      on_change: select_plan,
      class_name: "plans_buttons"
    }), active_plan && /*#__PURE__*/React.createElement(E.Plan_info, _extends({}, props, {
      plan: active_plan
    })));
  };
  E.feature_tips = {
    smart_dns: 'Smart DNS service replaces the DNS address provided by ' + 'your ISP with one for a different server. The location ' + 'depends on the server infrastructure of the provider. ' + 'This lets you access content that would otherwise not ' + 'be available where you live. ' + 'It’s important to note that this doesn’t give you a ' + 'new IP address – it just changes how a website sees ' + 'your IP address.\n' + 'For Online video streaming DNS is a better option, due ' + 'to its lightweight nature.'
  };
  return E;
});